<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">스케줄 예약</span>
            <span class="txt">수업에 대한 스케줄 예약, 수정, 취소를 할 수 있습니다.</span>
        </div>

        <div class="com-table-content">
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link class="com-btn blue" to="/madmin/course/care">목록보기</router-link>
                </div>
            </div>
            <div class="top-select">
                <select-form
                    :select-data="[...selectFormProduct.data]"
                    :select-value="[...selectFormProduct.value]"
                    :selected-value="selectFormProduct.selectedValue"
                    class="w420 blue-border"
                    @update:set="updateSelectProduct"
                ></select-form>
            </div>
            <table v-if="selectedContract" class="com-table td-left">
                <colgroup>
                    <col style="width: 160px" />
                    <col style="width: 340px" />
                    <col style="width: 160px" />
                    <col style="width: 270px" />
                    <col style="width: 160px" />
                    <col style="width: 270px" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>이용권명</th>
                        <td>
                            {{ convertTicketTypeFormat(ticketType) }}
                            {{ currentProduct.productName }}
                        </td>
                        <th>회원명</th>
                        <td>{{ customerName }}</td>
                        <th>센터명</th>
                        <td>{{ centerName }}</td>
                    </tr>
                    <tr>
                        <th>유효기간</th>
                        <td>
                            <span class="txt">
                                {{ currentProduct.expireStartDt }} ~{{ currentProduct.expireEndDt }}
                            </span>
                            <button
                                class="com-btn"
                                @click="
                                    checkAllowedClick('LE', 4, () => {
                                        onClickExtendDetail(currentProduct, 1);
                                    })
                                "
                            >
                                기간연장
                            </button>
                            <button
                                class="com-btn blue"
                                @click="
                                    checkAllowedClick('LE', 4, () => {
                                        onClickExtendDetail(currentProduct, 2);
                                    })
                                "
                            >
                                내역
                            </button>
                        </td>
                        <th>담당강사</th>
                        <td>
                            {{ teacherName }}
                        </td>
                        <th>수업현황</th>
                        <td>
                            <span v-if="currentProduct.lessonCountType === 'T'">
                                회당 {{ convertTicketLessonTime(currentProduct.centerProduct.lessonTime) }}, 총
                                {{ total_cnt }}/{{ currentProduct.lessonCount }}회
                            </span>
                            <span v-if="currentProduct.lessonCountType === 'W'">
                                회당 {{ convertTicketLessonTime(currentProduct.centerProduct.lessonTime) }}, 주
                                {{ total_cnt }}/{{ currentProduct.lessonCount }}회
                            </span>
                            <span v-if="currentProduct.lessonCountType === 'U'">
                                회당 {{ convertTicketLessonTime(currentProduct.centerProduct.lessonTime) }},
                                {{ total_cnt }}/무제한
                            </span>
                            <strong>
                                (출석
                                <span class="red">{{ currentProduct.lessonJoinCount }}</span>
                                / 결석
                                <span class="red">{{ currentProduct.lessonAbsentCount }}</span>
                                )
                            </strong>
                        </td>
                    </tr>
                    <tr>
                        <th>비고사항</th>
                        <td colspan="5"></td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div v-if="selectedContract" class="com-tab">
            <button class="on">스케줄 현황</button>
            <router-link
                :to="{
                    name: 'CourseCareHistory',
                    params: {
                        name: selectedCustomer.name,
                        title: selectedContract.productName,
                        type: ticketType,
                        custId: selectedContract.centerCustomerId,
                        contractId: selectedContract.centerContractId,
                    },
                }"
            >
                히스토리
            </router-link>
        </div>

        <div v-if="selectedContract" class="com-table-content">
            <div class="com-btn-area">
                <div class="left-box">
                    <button class="com-btn excel" @click="excelDownload">엑셀 다운로드</button>
                </div>
                <div class="right-box">
                    <template v-if="ticketType === 'G' || ticketType === 'C'">
                        <a class="com-btn red" href="#" @click="onClickBtnMultiCancelLessonReservation">
                            일괄 취소하기
                        </a>
                        <a class="com-btn" href="#" @click="onCalendar">일괄 예약하기</a>
                        <a class="com-btn blue" href="#" @click="onClickBtnGroupReservation">그룹레슨단건등록</a>
                        <!--그룹-->
                    </template>
                    <template v-else-if="ticketType === 'T'">
                        <a class="com-btn blue" href="#" @click="onClickBtnLessonBatchReservation">일괄 등록</a>
                        <!--개인,듀엣,OT-->
                        <a class="com-btn blue" href="#" @click="onClickBtnLessonReservation">등록</a>
                        <!--개인,듀엣,OT-->
                    </template>
                    <template v-else-if="ticketType === 'D'">
                        <a class="com-btn red" href="#" @click="onClickBtnMultiCancelLessonReservation">일괄 취소</a>
                        <a class="com-btn blue" href="#" @click="onClickBtnLessonBatchReservationNew">일괄 등록</a>
                        <!--듀엣-->
                        <a class="com-btn blue" href="#" @click="onClickBtnLessonReservation">등록</a>
                        <!--듀엣-->
                    </template>
                    <template v-else>
                        <a class="com-btn red" href="#" @click="onClickBtnMultiCancelLessonReservation">일괄 취소</a>
                        <a class="com-btn blue" href="#" @click="onClickBtnLessonBatchReservationNew">일괄 등록</a>
                        <!--듀엣-->
                        <!--
                        <a class='com-btn blue'
                           href='#'
                           @click='onClickBtnLessonBatchReservation'>일괄 등록</a>
                        개인,듀엣,OT -->
                        <a class="com-btn blue" href="#" @click="onClickBtnLessonReservation">등록</a>
                        <!--개인,듀엣,OT-->
                    </template>
                </div>
            </div>
            <table class="com-table">
                <colgroup>
                    <col style="width: 60px" />
                    <col style="width: 60px" />
                    <col style="width: 150px" />
                    <col style="width: 170px" />
                    <col style="width: 150px" />
                    <col style="width: 150px" />
                    <col style="width: 280px" />
                    <col style="width: 110px" />
                    <col style="width: 150px" />
                    <col style="width: 130px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <div class="com-check">
                                <input
                                    id="check-1-1"
                                    v-model="selectAll"
                                    name="check-1"
                                    type="checkbox"
                                    @change="allCheckBox"
                                />
                                <label for="check-1-1"></label>
                            </div>
                        </th>
                        <th>
                            <button>회차</button>
                        </th>
                        <th>
                            <button>강사명</button>
                        </th>
                        <th>
                            <button @click="toggleAsc">수업일자({{ this.dateAsc ? '오름차순' : '내림차순' }})</button>
                        </th>
                        <th>
                            <button>시작시간</button>
                        </th>
                        <th>수업시간</th>
                        <th>룸 선택</th>
                        <th>관리</th>
                        <th>출결현황</th>
                        <th>정산현황</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(s, index) in searchList" :key="index">
                        <td>
                            <div class="com-check">
                                <input
                                    :id="`check-1-1-${index + 1}`"
                                    v-model="checkScheduleList"
                                    :value="s"
                                    name="check-1"
                                    type="checkbox"
                                    :disabled="s.clsc_atnd_status_cd !== '-'"
                                />
                                <label :for="`check-1-1-${index + 1}`"></label>
                            </div>
                        </td>
                        <td>{{ index + 1 }}</td>
                        <td>{{ s.cls_less_staff_nm }}</td>
                        <td>{{ s.cls_less_dt | formatDate("YYYY-MM-DD (ddd)") }}</td>
                        <td>{{ s.cls_less_start_tm | timeCutter }}</td>
                        <td>{{ convertLessonTime(s.cls_less_total_tm) }}</td>
                        <td class="left">
                            <div class="info-line">
                                <span v-for="(room, index) in getRoomInfos(s.cls_center_room_info)" :key="index">
                                    <span class="time">
                                        {{ room.startTime | formatHourMinutes }} ~
                                        {{ room.endTime | formatHourMinutes }}
                                    </span>
                                    {{ room.name }}
                                </span>
                            </div>
                        </td>
                        <td>
                            <template v-if="isCancelStatus(s)">취소됨</template>
                            <template
                                v-else-if="
                                    isAllowedModify(s) &&
                                    s.clsc_atnd_status_cd === '-' &&
                                    checkTeacherReservDatetime(s.cls_less_dt, s.cls_less_start_tm)
                                "
                            >
                                <button class="com-btn" @click="onClickBtnChangeLessonReservation(s)">변경</button>
                                <button class="com-btn red" @click="onClickBtnCancelLessonReservation(s)">취소</button>
                            </template>
                        </td>
                        <td>
                            <div v-if="isCancelStatus(s)" class="info-line"></div>
                            <div v-else-if="s.clsc_atnd_status_cd === '-'" class="info-line">
                                <button
                                    class="com-btn"
                                    @click="
                                        checkAllowedClickAttendAction(s, () => {
                                            onAttendCheck(
                                                s,
                                                s.cls_center_less_schd_id,
                                                s.clsc_join_seq,
                                                s.clsc_center_cust_id
                                            );
                                        })
                                    "
                                >
                                    출결승인
                                </button>
                            </div>
                            <div v-else-if="s.clsc_atnd_status_cd === 'X'" class="info-line">
                                <span>
                                    <span class="red">결석</span>
                                    ({{ s.clsc_atnd_exec_tm | timestampFilter3 }})
                                    <button
                                        class="com-btn gray"
                                        @click="
                                            checkAllowedClickAttendAction(s, () => {
                                                onAttendCancel(
                                                    s.cls_center_less_schd_id,
                                                    s.clsc_join_seq,
                                                    s.clsc_center_cust_id,
                                                    '-',
                                                    s
                                                );
                                            })
                                        "
                                    >
                                        출결취소
                                    </button>
                                </span>
                            </div>
                            <div v-else-if="s.clsc_atnd_status_cd === 'O'" class="info-line">
                                <span>
                                    <span>출석</span>
                                    ({{ s.clsc_atnd_exec_tm | timestampFilter3 }})
                                    <button
                                        class="com-btn gray"
                                        @click="
                                            checkAllowedClickAttendAction(s, () => {
                                                onAttendCancel(
                                                    s.cls_center_less_schd_id,
                                                    s.clsc_join_seq,
                                                    s.clsc_center_cust_id,
                                                    '-',
                                                    s
                                                );
                                            })
                                        "
                                    >
                                        출결취소
                                    </button>
                                </span>
                            </div>
                        </td>
                        <td>
                            <span v-if="s.clsc_atnd_status_cd === '-' && s.clsc_bill_status_cd === '-'">미정산</span>
                            <div
                                v-else-if="s.clsc_atnd_status_cd !== '-' && s.clsc_bill_status_cd === 'O'"
                                class="info-line"
                            >
                                <span>완료 {{ convertBillTime(s.clsc_bill_exec_tm) }}</span>
                                <span>
                                    <button
                                        class="com-btn gray"
                                        @click="
                                            checkAllowedClick('LE', 7, () => {
                                                payCancel(s.cls_center_less_schd_id, s.clsc_center_cust_id);
                                            })
                                        "
                                    >
                                        정산취소
                                    </button>
                                </span>
                            </div>
                            <div
                                v-else-if="s.clsc_bill_status_cd !== 'O' && s.clsc_atnd_status_cd !== '-'"
                                class="info-line"
                            >
                                <button
                                    class="com-btn"
                                    @click="
                                        checkAllowedClick('LE', 7, () => {
                                            payApproval(
                                                s.cls_center_less_schd_id,
                                                s.clsc_center_cust_id,
                                                s.clsc_center_contract_id
                                            ); // duk : contractId 이 값 확인해바야댐.
                                        })
                                    "
                                >
                                    정산승인
                                </button>
                            </div>
                            <!--
            <div class="info-line" v-if="s.clsc_bill_status_cd == 'X'">
                <button class="com-btn" @click="payApproval(s.cls_center_less_schd_id,s.clsc_center_cust_id)">정산승인</button>
            </div>
            -->
                        </td>
                    </tr>
                    <tr v-if="searchList.length == 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
            <b-pagination
                v-model="pagingInfo.page"
                :per-page="pagingInfo.limit"
                :total-rows="pagingInfo.totalItems"
                align="center"
                aria-controls="my-table"
                first-class="first"
                last-class="last"
                next-class="next"
                prev-class="prev"
                @change="handlerPagenation($event)"
            ></b-pagination>
        </div>

        <!-- 그룹 일괄예약 레이어 팝업 -->
        <div v-if="selectedContract" v-show="groupPop" class="layer-pop square">
            <div class="view-content w1040" style='display: flex; flex-direction: column'>
                <button class="close" @click="onCloseCalendar">
                    <span class="blind">팝업 닫기</span>
                </button>

                <div>
                    <span class="title">
                        그룹 일괄예약
                        <small>원하는 수업을 체크 후 [일괄예약] 버튼을 클릭해 주세요.</small>
                    </span>

                    <div class="top-select">
                        <select-form
                            :disabled="isDisableSelectStaffs"
                            :select-data="['선택', ...staffNameList]"
                            :select-value="['', ...staffValueList]"
                            :selected-value="calendarStaffId ? parseInt(calendarStaffId) : ''"
                            class="select-form-dropdown"
                            style='width: 210px;'
                            @update:set="onUpdateStaff"
                        />

                        <select-form
                            :select-data="timeValues"
                            :select-value="timeValues"
                            :selected-value="timeValues[0]"
                            class="select-form-dropdown"
                            style='width: 108px;'
                            @update:set="onUpdateMonth"
                        />

                        <span class="txt" style='flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;'>
                            {{ convertTicketTypeFormat(ticketType) }}
                            {{ currentProduct.productName }}
                            [{{ expireStartDate }} ~ {{ expireEndDate }}]
                        </span>

                        <div class="break"></div>

                        <div style='flex-grow: 1; text-align: right'>
                            <span class="txt" style='margin-right: 8px;'>총 {{ countCheckedCalendar }}건 선택</span>
                            <button class="com-btn blue" @click="onGroupLessonBatch">일괄예약</button>
                        </div>
                    </div>
                </div>

                <div class="scroll-area com-scroll-y" style='flex: 1; max-height: unset !important;'>
                    <!-- 그룹 예약 테이블 -->
                    <group-reserve-table
                        v-for="(ym, index) in timeValues"
                        :key="index"
                        ref="groupReserveTable"
                        :end-date="expireEndDate"
                        :lesson-count="currentProduct.lessonCount"
                        :lesson-count-type="currentProduct.lessonCountType"
                        :productId="currentProduct.centerProductId"
                        :reservation-limit-date="groupReservationLimitDate"
                        :reserved-schedule-ids="allLessonScheduleIds"
                        :reserved-schedules="allLessonSchedule"
                        :seq="index"
                        :staffId="calendarStaffId"
                        :start-date="expireStartDate"
                        :yearMonth="ym"
                        @update:set="onUpdateCheckLessonReserve"
                    />
                    <!-- //그룹 예약 테이블 -->
                </div>
            </div>
        </div>
        <!-- 그룹 일괄 예약 확인 팝업 -->
        <div v-show="infoPop" class="layer-pop square-type">
            <div class="view-content w480">
                <button class="close" @click="onCloseGroupBatchResult">
                    <span class="blind">팝업 닫기</span>
                </button>
                <div class="scroll-area com-scroll-y info">
                    <span class="sub-title">그룹 일괄예약</span>
                    <p class="info-txt">체크한 날짜에 일괄예약이 저장되었습니다.</p>
                    <div class="bottom-btn">
                        <button class="com-btn blue" @click="onCloseGroupBatchResult">확인</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 기간연장 팝업(삭제) -->
        <div v-if="false" v-show="false" class="layer-pop square-type">
            <div class="view-content w880">
                <button class="close" @click="periodPop = false">
                    <span class="blind">팝업 닫기</span>
                </button>
                <div class="scroll-area com-scroll-y">
                    <div class="com-tab">
                        <button :class="{ on: layerTab === 1 }" @click="layerTab = 1">기간연장</button>
                        <button :class="{ on: layerTab === 2 }" @click="onExtPeriod">연장내역</button>
                    </div>
                    <!-- 기간연장 -->
                    <div v-show="layerTab === 1" class="view-area">
                        <table class="com-table left">
                            <colgroup>
                                <col style="width: 160px" />
                                <col style="width: 600px" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>회원명</th>
                                    <td>{{ customerName }}</td>
                                </tr>
                                <tr>
                                    <th>이용권명</th>
                                    <td>
                                        <!-- <span class="ico type-1" v-if="prod.centerProduct.ticketType == 'P'">[개인]</span>
                  <span class="ico type-2" v-if="prod.centerProduct.ticketType == 'G'">[그룹]</span>
                  <span class="ico type-3" v-if="prod.centerProduct.ticketType == 'P'">[패키지]</span>
                  <span class="ico type-4" v-if="prod.centerProduct.ticketType == 'C'">[회원권]</span>
                  <span class="ico type-5" v-if="prod.centerProduct.ticketType == 'D'">[듀엣]</span>
                  <span class="ico type-6" v-if="prod.centerProduct.ticketType == 'O'">[OT]</span> -->
                                        <!-- <span :class="{'ico': true, 'type-1': prod.centerProduct.ticketType === 'P', 'type-2': prod.centerProduct.ticketType === 'G',
                      'type-4': prod.centerProduct.ticketType === 'T', 'type-5': prod.centerProduct.ticketType === 'D', 'type-6': prod.centerProduct.ticketType === 'O' }">
                  {{ convertTicketTypeFormat(prod.centerProduct.ticketType) }} -->
                                        <!-- </span> -->
                                        {{ selectedExtendDetail.productName }}
                                    </td>
                                </tr>
                                <tr>
                                    <th>현재 유효기간</th>
                                    <td>{{ expireStartDate }}~{{ expireEndDate }}</td>
                                </tr>
                                <tr>
                                    <th>유형</th>
                                    <td>
                                        <div class="line">
                                            <div class="com-radio">
                                                <input
                                                    id="radio-pop-1"
                                                    v-model="editField.expirePlusType"
                                                    name="radio-pop"
                                                    type="radio"
                                                    value="N"
                                                />
                                                <label for="radio-pop-1">연기 (단순 기간연기)</label>
                                            </div>
                                        </div>
                                        <div class="line">
                                            <div class="com-radio">
                                                <input
                                                    id="radio-pop-2"
                                                    v-model="editField.expirePlusType"
                                                    name="radio-pop"
                                                    type="radio"
                                                    value="H"
                                                />
                                                <label for="radio-pop-2">홀딩 (연장 기간동안 예약 및 입장 불가)</label>
                                            </div>
                                        </div>
                                        <span class="red">
                                            <span class="imp">*</span>
                                            홀딩 기간 중 예약은 자동 취소 됩니다.
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        연장기간
                                        <span class="imp">*</span>
                                    </th>
                                    <td>
                                        <div class="line">
                                            <single-calendar
                                                :start-date="editField.expirePlusStartDt"
                                                @update="updateExpStartDt"
                                            ></single-calendar>
                                            ~
                                            <single-calendar
                                                :end-date="editField.expirePlusEndDt"
                                                @update="updateExpEndDt"
                                            ></single-calendar>
                                        </div>
                                        <div class="line">
                                            <input
                                                v-model="editField.expirePlusDay"
                                                class="center w60"
                                                type="text"
                                                @keypress="isNumber($event)"
                                                @keyup="onInputExpPlusDay"
                                            />
                                            <span class="txt">일</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>변경 후 유효기간</th>
                                    <td>
                                        <span class="red">{{ expireStartDate }} ~ {{ calExpEndDt }}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        등록자
                                        <span class="imp">*</span>
                                    </th>
                                    <td>
                                        <select-form
                                            :select-data="['선택', ...expPlusStaffList]"
                                            :select-value="['', ...expPlusStaffValueList]"
                                            :selected-value="editField.expirePlusStaffId"
                                            class="w120"
                                            @update:set="(val) => (editField.expirePlusStaffId = val)"
                                        ></select-form>
                                    </td>
                                </tr>
                                <tr>
                                    <th>연기 사유</th>
                                    <td>
                                        <textarea v-model="editField.expirePlusMemo" class="full"></textarea>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="bottom-btn">
                            <button class="com-btn" @click="periodPop = false">취소</button>
                            <button class="com-btn blue" @click="onPostExtPeriod">등록</button>
                        </div>
                    </div>
                    <!-- //기간연장 -->
                    <!-- 연장내역 -->
                    <div v-show="layerTab == 2" class="view-area">
                        <div class="user-info-box">
                            <div class="line">
                                <span class="name">{{ customerName }}</span>
                                <span class="first right">
                                    최초 유효기간 |{{ currentProduct.orgExpireStartDt }} ~{{
                                        currentProduct.orgExpireEndDt
                                    }}
                                </span>
                            </div>
                            <div class="line">
                                <span class="name">
                                    <span
                                        :class="{
                                            ico: true,
                                            'type-1': ticketType === 'P',
                                            'type-2': ticketType === 'G',
                                            'type-4': ticketType === 'T',
                                            'type-5': ticketType === 'D',
                                            'type-6': ticketType === 'O',
                                            'type-8': ticketType === 'S',
                                        }"
                                    >
                                        {{ convertTicketTypeFormat(ticketType) }}
                                    </span>
                                    {{ currentProduct.productName }}
                                </span>
                                <span class="now right">
                                    현재 유효기간 | {{ expireStartDate }} ~ {{ expireEndDate }}
                                </span>
                            </div>
                            <div class="line">
                                <span class="cnt right">총 연장횟수 : {{ extPeriodList.length }}회</span>
                            </div>
                        </div>
                        <table class="com-table">
                            <colgroup>
                                <col style="width: 90px" />
                                <col style="width: 150px" />
                                <col style="width: 150px" />
                                <col style="width: 150px" />
                                <col style="width: 150px" />
                                <col style="width: 80px" />
                                <col style="width: 80px" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>등록일</th>
                                    <th>연장기간</th>
                                    <th>변경 전 기간</th>
                                    <th>변경 후 기간</th>
                                    <th>연기사유</th>
                                    <th>유형</th>
                                    <th>관리</th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- <tr>
                  <td>2020.01.20<br>13:00:32</td>
                  <td>
                      2020.01.20 ~<br>2020.01.30
                      <div class="line">
                          <span class="red">(10일)</span>
                      </div>
                  </td>
                  <td>2020.01.10 ~<br>2020.01.20</td>
                  <td>2020.01.10 ~<br>2020.01.20</td>
                  <td>겨울휴가</td>
                  <td>홀딩</td>
                  <td>
                      <div class="line">
                          <button class="com-btn red">삭제</button>
                      </div>
                      <div class="line">
                          <button class="com-btn">수정</button>
                      </div>
                  </td>
              </tr> -->
                                <tr v-for="(e, index) in extPeriodList" :key="index">
                                    <td>{{ e.c_cre_dt | timestampFilter2 }}</td>
                                    <td>
                                        {{ e.c_exp_plus_start_dt | timestampFilter }} ~
                                        <br />
                                        {{ e.c_exp_plus_end_dt | timestampFilter }}
                                        <div class="line">
                                            <span class="red">({{ e.c_exp_plus_day }}일)</span>
                                        </div>
                                    </td>
                                    <td>
                                        {{ e.c_org_exp_start_dt | timestampFilter }}
                                        ~
                                        <br />
                                        {{ e.c_org_exp_end_dt | timestampFilter }}
                                    </td>
                                    <td>
                                        {{ e.c_exp_start_dt | timestampFilter }}
                                        ~
                                        <br />
                                        {{ e.c_exp_end_dt | timestampFilter }}
                                    </td>
                                    <td>{{ e.c_exp_plus_memo }}</td>
                                    <td>
                                        {{ convertPlusType(e.c_exp_plus_type_cd) }}
                                    </td>
                                    <td>
                                        <div v-if="index === 0" class="line">
                                            <button
                                                class="com-btn red"
                                                @click="checkAllowedClick('LE', 4, onDeleteExtPeriod)"
                                            >
                                                삭제
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                                <tr v-if="extPeriodList.length === 0">
                                    <td colspan="100">등록된 내용이 없습니다.</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="bottom-btn">
                            <button class="com-btn" @click="periodPop = false">취소</button>
                            <!-- <button class="com-btn blue">등록</button> -->
                        </div>
                    </div>
                    <!-- //연장내역 -->
                </div>
            </div>
        </div>

        <!-- 중복예약 알림 팝업 -->
        <div v-show="overlapPop" class="layer-pop square-type">
            <div class="view-content w480">
                <button class="close" @click="overlapPop = false">
                    <span class="blind">팝업 닫기</span>
                </button>
                <div class="scroll-area com-scroll-y info">
                    <span class="sub-title">중복예약 알림</span>
                    <p class="info-txt">
                        해당 시간에는 이미 예약된 내역이 있어
                        <span class="red">중복예약</span>
                        됩니다.
                        <br />
                        그래도 예약하시겠습니까?
                    </p>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="overlapPop = false">취소</button>
                        <button class="com-btn blue">확인</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 출결승인 팝업 -->
        <div v-if="selectedContract" v-show="attendPop" class="layer-pop square-type">
            <div class="view-content w650">
                <button class="close" @click="attendPop = false">
                    <span class="blind">팝업 닫기</span>
                </button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">출결승인</span>
                    <div class="attend-info-area">
                        <span class="top-user">
                            <strong>{{ customerName }}</strong>
                            회원님
                            <!-- <span class="ico type-1">[개인]</span> -->
                            <!--
                          <span class="ico type-2">[그룹]</span>
                          <span class="ico type-3">[패키지]</span>
                          <span class="ico type-4">[회원권]</span>
                          <span class="ico type-5">[듀엣]</span>
                          <span class="ico type-6">[OT]</span>
                          -->
                            {{ convertTicketTypeFormat(ticketType) }}
                            {{ currentProduct.productName }}
                        </span>
                        <div class="info-box">
                            <span class="time">
                                {{ userAttendInfo.cls_less_dt | timestampFilter }}
                                {{ userAttendInfo.cls_less_start_tm | timeCutter }} ({{
                                    userAttendInfo.cls_less_staff_nm
                                }}
                                강사)
                            </span>
                            <div class="input-line">
                                <input
                                    v-model="absentReason"
                                    class="w100p"
                                    placeholder="결석일 경우, 사유를 입력해주세요."
                                    type="text"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="bottom-btn">
                        <button class="com-btn blue" @click="attendCheck('O')" :disabled="isLoading">출석처리</button>
                        <button class="com-btn red" @click="attendCheck('X')" :disabled="isLoading">결석처리</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 스케줄 예약 팝업 -->
        <div v-show="reservationPop" class="layer-pop square-type">
            <div class="view-content w950">
                <button class="close" @click="onClickBtnCancelReservation"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">{{ reservationPop ? '스케줄 예약' : '스케줄 일괄 예약' }}</span>
                    <br />
                    <!-- 스케줄예약, 스케줄수정 -->
                    <lesson-reservation-dlg
                        v-show="reservationPop"
                        ref="lessonReservationDlg"
                        :callback-cancel="onCancelLessonReservationDlg"
                        :callback-success="onSuccessLessonReservationDlg"
                        :init-center-id="centerId"
                        :select-form-teacher="selectFormTeacher"
                    />
                    <!-- //스케줄예약, 스케줄수정 -->
                </div>
            </div>
        </div>
        <!-- //스케줄예약, 스케줄수정 -->

        <div v-if="selectedContract" v-show="batchReservationPop" class="layer-pop square">
            <div class="view-content w1040">
                <button class="close" @click="onCloseCalendar">
                    <span class="blind">팝업 닫기</span>
                </button>
                <div class="scroll-area com-scroll-y">
                    <span class="title">
                        개인 일괄예약
                        <small>원하는 수업을 체크 후 [일괄예약] 버튼을 클릭해 주세요.</small>
                    </span>

                    <div class="top-select">
                        <select-form
                            :disabled="isDisableSelectStaffs"
                            :select-data="['선택', ...staffNameList]"
                            :select-value="['', ...staffValueList]"
                            :selected-value="calendarStaffId ? parseInt(calendarStaffId) : ''"
                            class="w200"
                            @update:set="onUpdateStaff"
                        />
                        <span class="txt">
                            {{ convertTicketTypeFormat(ticketType) }}
                            {{ currentProduct.productName }}
                            [{{ expireStartDate }} ~ {{ expireEndDate }}]
                        </span>
                        <div style="display: flex; justify-content: space-between">
                            <div style="display: flex; align-items: center">
                                <span>
                                    수업시작시간
                                    <span class="imp">*</span>
                                </span>
                                <select-form
                                    :select-data="selectFormStartHour.data"
                                    :select-value="selectFormStartHour.value"
                                    :selected-value="selectFormStartHour.selectedValue"
                                    class="w100"
                                    @update:set="updateReserveHour"
                                />
                                <span class="dot">:</span>
                                <select-form
                                    :select-data="selectFormStartMin.data"
                                    :select-value="selectFormStartMin.value"
                                    :selected-value="selectFormStartMin.selectedValue"
                                    class="w100"
                                    @update:set="updateReserveMin"
                                />
                                <div v-for="(room, index) in rooms" :key="index" style="display: flex">
                                    <div>
                                        <span style="margin-right: 8px; margin-left: 8px">룸 선택</span>
                                        <select-form
                                            :select-data="[...selectRoom(index).data]"
                                            :select-value="[...selectRoom(index).value]"
                                            :selected-value="room.centerRoomId"
                                            class="w170"
                                            @update:set="
                                                (val) => {
                                                    updateEditFieldReservCenterRoom(val, room, index);
                                                }
                                            "
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="float-right">
                                <span class="txt">
                                    총
                                    {{
                                        Object.keys(this.batchLesson).length === 0
                                            ? 0
                                            : Object.values(this.batchLesson).reduce((a, b) => [...a, ...b]).length
                                    }}건 선택
                                </span>
                                <button class="com-btn blue" @click="onLessonBatch" :disabled="batchLoading">
                                    일괄예약
                                </button>
                            </div>
                        </div>
                    </div>
                    <batch-reserve-table
                        v-for="(ym, index) in timeValues"
                        :key="index"
                        ref="batchReserveTable"
                        :end-date="expireEndDate"
                        :left-count="currentProduct.lessonCount - total_cnt"
                        :lesson-count="currentProduct.lessonCount"
                        :lesson-count-type="currentProduct.lessonCountType"
                        :productId="currentProduct.centerProductId"
                        :reservation-limit-date="groupReservationLimitDate"
                        :reserved-schedule-ids="allLessonScheduleIds"
                        :reserved-schedules="allLessonSchedule"
                        :seq="index"
                        :staffId="calendarStaffId"
                        :start-date="expireStartDate"
                        :target-time="selectFormStartHour.selectedValue + ':' + selectFormStartMin.selectedValue"
                        :lessonTime="convertTicketLessonTime(currentProduct.centerProduct.lessonTime)"
                        :yearMonth="ym"
                        @update:set="onUpdateCheckBatchLessonReserve"
                    />
                    <!-- //그룹 예약 테이블 -->
                </div>
            </div>
        </div>

        <!-- 새로운 일괄 등록-->
        <div v-if="selectedContract" v-show="batchReservationPopNew" class="layer-pop square">
            <div class="view-content w1040">
                <button class="close" @click="onCloseCalendarNew">
                    <span class="blind">팝업 닫기</span>
                </button>
                <div class="scroll-area com-scroll-y">
                    <span class="title">일괄예약</span>
                    <div class="com-table-content">
                        <table v-if="selectedContract" class="com-table td-left">
                            <colgroup>
                                <col style="width: 25%" />
                                <col style="width: 30%" />
                                <col style="width: 45%" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>
                                        이용권 종류
                                        <span class="imp">*</span>
                                    </th>
                                    <td colspan="2">
                                        <div class="info flex">
                                            <div class="com-radio">
                                                <input
                                                    id="reserveTypeMultiP"
                                                    name="reserveTypeMulti"
                                                    v-model="reserveTypeMulti"
                                                    :disabled="true"
                                                    type="radio"
                                                    value="P"
                                                />
                                                <label for="reserveTypeMultiP">개인</label>
                                            </div>
                                            <div class="com-radio">
                                                <input
                                                    id="reserveTypeMultiD"
                                                    name="reserveTypeMulti"
                                                    v-model="reserveTypeMulti"
                                                    :disabled="true"
                                                    type="radio"
                                                    value="D"
                                                />
                                                <label for="reserveTypeMultiD">듀엣</label>
                                            </div>
                                            <div class="com-radio">
                                                <input
                                                    id="reserveTypeMultiG"
                                                    name="reserveTypeMulti"
                                                    v-model="reserveTypeMulti"
                                                    :disabled="true"
                                                    type="radio"
                                                    value="G"
                                                />
                                                <label for="reserveTypeMultiG">그룹</label>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        강사 선택
                                        <span class="imp">*</span>
                                    </th>
                                    <td colspan="2">
                                        <select-form
                                            :disabled="isDisableSelectStaffs"
                                            :select-data="['선택', ...staffNameList]"
                                            :select-value="['', ...staffValueList]"
                                            :selected-value="duetCalendarStaffId ? parseInt(duetCalendarStaffId) : ''"
                                            class="w200"
                                            @update:set="onUpdateStaffDuet"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        함께 등록할 회원 선택
                                        <span class="imp">*</span>
                                    </th>
                                    <td colspan="2">
                                        <select-form-search
                                            v-if="centerContractBillTicketNameList.length > 0"
                                            :disabled="ticketType === 'P' || ticketType === 'O'"
                                            :select-data="['선택', ...centerContractBillTicketNameList]"
                                            :select-value="['', ...centerContractBillTicketValueList]"
                                            :selected-value="''"
                                            class="w600"
                                            style="margin-bottom: 10px"
                                            @update:set="onUpdateTicketWith"
                                        />
                                        <div
                                            v-for="(ticket, index) in selectedTicketList"
                                            :key="index"
                                            class=""
                                            style="width: 600px"
                                        >
                                            <div
                                                class="input-del"
                                                :style="
                                                    centerContractId !== selectedTicketValueList[index].centerContractId
                                                        ? 'background-color: #00C7E5'
                                                        : 'background-color: #4DB650'
                                                "
                                                style="
                                                    font-size: 13px;
                                                    color: white;
                                                    padding: 0px 0px 20px 15px;
                                                    margin-top: 10px;
                                                "
                                            >
                                                <div style="display: inline-block; width: 95%; white-space: pre-line">
                                                    {{ ticket }}
                                                </div>
                                                <button
                                                    v-if="
                                                        centerContractId !==
                                                        selectedTicketValueList[index].centerContractId
                                                    "
                                                    @click="deleteTicket(index)"
                                                    class="del2"
                                                ></button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <!-- 선택된 이용권
                            <tr>
                                <th>선택된 이용권<span class='imp'>*</span></th>
                                <td colspan="2">
                                    <div v-for='(ticket, index) in selectedTicketList' :key='index' class='' style='width:630px;'>
                                        <div class='input-del' :style="centerContractId !== selectedTicketValueList[index].cc_center_contract_id ? 'background-color: #00C7E5' : 'background-color: #4DB650'"
                                        style="color:white;padding: 20px">
                                            {{ ticket }}
                                        <button v-if="centerContractId !== selectedTicketValueList[index].cc_center_contract_id" @click='deleteTicket(index)' class='del'></button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            -->
                                <tr>
                                    <th>
                                        수업 옵션 선택
                                        <span class="imp">*</span>
                                    </th>
                                    <td colspan="2">
                                        <select-form
                                            :select-data="selectFormStartTime.data"
                                            :select-value="selectFormStartTime.value"
                                            :selected-value="selectFormStartTime.selectedValue"
                                            class="w100"
                                            @update:set="updateReserveStartTime"
                                        />
                                        <span class="dot">:</span>
                                        <select-form
                                            disabled
                                            :select-data="selectFormEndTime.data"
                                            :select-value="selectFormEndTime.value"
                                            :selected-value="selectFormEndTime.selectedValue"
                                            class="w100"
                                            @update:set=""
                                        />
                                        <div v-for="(room, index) in rooms" :key="index" style="display: inline">
                                            <span style="margin-right: 8px; margin-left: 8px">룸 선택</span>
                                            <select-form
                                                :select-data="[...selectRoom(index).data]"
                                                :select-value="[...selectRoom(index).value]"
                                                :selected-value="room.centerRoomId"
                                                class="w170"
                                                @update:set="
                                                    (val) => {
                                                        updateEditFieldReservCenterRoomNew(val, room, index);
                                                    }
                                                "
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        일정 선택
                                        <span class="imp">*</span>
                                    </th>
                                    <td style="border-right: none">
                                        <div class="flexbox" style="justify-content: space-between">
                                            <div style="color: #777777; font-size: 13px">
                                                달력에서 날짜를 선택해주세요.
                                            </div>
                                        </div>
                                        <div style="color: #777777; font-size: 13px">
                                            선택한 날짜를 다시 누르면 일정이 해제됩니다.
                                        </div>
                                        <div class="flexbox" style="justify-content: flex-start">
                                            <schedule-calendar
                                                style="margin-top: 10px; margin-bottom: 10px"
                                                ref="lessonDate"
                                                :isPickDate="true"
                                                :ticketType="ticketType"
                                                :staffId="duetCalendarStaffId"
                                                :staffNameList="staffNameList"
                                                :staffValueList="staffValueList"
                                                :centerId="centerId"
                                                :centerLessonScheduleId="centerLessonScheduleId"
                                                :startTime="selectFormStartTime.selectedValue"
                                                :endTime="selectFormEndTime.selectedValue"
                                                :reservedScheduleList="reservedScheduleList"
                                                :selectedScheduleList="selectedScheduleList"
                                                :selectedScheduleValueList="selectedScheduleValueList"
                                                :selectFormRoom="selectFormRoom"
                                                :selectedRoom="selectedRoom"
                                                :selectedTicketValueList="selectedTicketValueList"
                                                :lessonTime="currentProduct.centerProduct.lessonTime"
                                                @update="updateLessonDate"
                                            ></schedule-calendar>
                                        </div>
                                        <div class="flexbox" style="align-items: center; justify-content: flex-start">
                                            <div class="reserved-circle"></div>
                                            <div style="margin-left: 5px; color: #777777; font-size: 13px">
                                                조회된 옵션에 이미 등록된 일정이 있는 경우
                                            </div>
                                        </div>
                                        <div class="flexbox" style="align-items: center; justify-content: flex-start">
                                            <div class="selected-circle"></div>
                                            <div style="margin-left: 5px; color: #777777; font-size: 13px">
                                                선택한 일정
                                            </div>
                                        </div>
                                    </td>
                                    <td style="vertical-align: top">
                                        <div class="flexbox" style="justify-content: flex-end">
                                            <span>{{ selectedScheduleList.length }} 회 선택됨</span>
                                            <button @click="onClickBtnInitSelectedScheduleList" class="com-btn">
                                                선택 초기화
                                            </button>
                                        </div>
                                        <div
                                            class="flexbox scroll-area com-scroll-y"
                                            style="flex-direction: column; justify-content: space-between"
                                        >
                                            <div class="input-del" style="font-size: 14px; height: 280px">
                                                선택한 일정
                                                <div v-for="(selected, index) in selectedScheduleList" :key="index">
                                                    {{ selected }}
                                                    <button @click="deleteSchedule(index)" class="del"></button>
                                                </div>
                                            </div>
                                            <div style="font-size: 14px">
                                                이미 등록된 일정
                                                <div v-for="(reserved, index) in reservedScheduleList" :key="index">
                                                    {{ reserved }}
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="bottom-btn">
                            <button class="com-btn" @click="onClickBtnCancelReservation">취소</button>
                            <button class="com-btn blue" @click="onClickBtnRegistDuetReservation">등록</button>
                        </div>
                    </div>
                    <!-- //그룹 예약 테이블 -->
                </div>
            </div>
        </div>

        <!-- 스케줄 예약 팝업 -->
        <div v-show="groupReservPop" class="layer-pop square-type">
            <div class="view-content w950">
                <button class="close" @click="onClickBtnCancelGroupReservation">
                    <span class="blind">팝업 닫기</span>
                </button>
                <div class="scroll-area com-scroll-y h450">
                    <span class="sub-title">그룹 레슨 예약</span>
                    <br />
                    <!-- 스케줄예약, 스케줄수정 -->
                    <group-lesson-reservation-dlg
                        ref="groupReservationDlg"
                        :callback-cancel="onCancelGroupReservationDlg"
                        :callback-success="onSuccessGroupReservationDlg"
                        :init-center-id="centerId"
                        :select-form-teacher="selectFormTeacher"
                    ></group-lesson-reservation-dlg>
                    <!-- //스케줄예약, 스케줄수정 -->
                </div>
            </div>
        </div>
        <!-- //스케줄예약, 스케줄수정 -->

        <period-pop
            v-if="periodPop"
            v-bind="periodPopProps"
            @close="periodPop = false"
            @period-init="periodInit"
        ></period-pop>
    </div>
</template>

<script>
import { maskCustomerPhone } from '@/assets/js/customerPhone';
import api from '@/assets/js/api';
import { pagingInfo } from '@/assets/js/common';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import { Utils } from '@/assets/js/utils';
import BatchReserveTable from '@/components/BatchReserveTable';
import GroupLessonReservationDlg from '@/components/GroupLessonReservationDlg';
import LessonReservationDlg from '@/components/LessonReservationDlg';
import moment from 'moment';
import XLSX from 'xlsx';

export default {
    name: 'CourseCareReserve',
    mixins: [MixinAllowedMenu],
    props: {},
    components: {
        BatchReserveTable,
        LessonReservationDlg,
        GroupLessonReservationDlg,
    },
    computed: {
        isDisableSelectStaffs() {
            // 권한 적용여부에 따라 disabled를 해제
            return !this.isAllowed('SC', 1);
        },
        currentProduct() {
            if (
                !Utils.isEmpty(this.selectedContract) &&
                !Utils.isEmpty(this.selectedContract.centerContractProducts) &&
                this.selectedContract.centerContractProducts.length > 0 &&
                !Utils.isEmpty(this.selectedContract.centerContractProducts[this.productIndex])
            ) {
                return this.selectedContract.centerContractProducts[this.productIndex];
            }

            return {};
        },
        customerName() {
            return !Utils.isEmpty(this.selectedCustomer) ? this.selectedCustomer.name : '';
        },
        centerName() {
            return !Utils.isEmpty(this.selectedContract) ? this.selectedContract.center.centerName : '';
        },
        teacherName() {
            return !Utils.isEmpty(this.currentProduct.teacher) ? this.currentProduct.teacher.name : '';
        },
        teacherId() {
            return !Utils.isEmpty(this.currentProduct.lessonStaffId) ? this.currentProduct.lessonStaffId : '';
        },
        ticketType() {
            if (
                !Utils.isEmpty(this.currentProduct.centerProduct) &&
                !Utils.isEmpty(this.currentProduct.centerProduct.ticketType)
            ) {
                return this.currentProduct.centerProduct.ticketType;
            }
            return '';
        },
        reserveTypeMulti() {
            if (
                !Utils.isEmpty(this.currentProduct.centerProduct) &&
                !Utils.isEmpty(this.currentProduct.centerProduct.ticketType)
            ) {
                return this.currentProduct.centerProduct.ticketType == 'O' ||
                    this.currentProduct.centerProduct.ticketType == 'P'
                    ? 'P'
                    : this.currentProduct.centerProduct.ticketType;
            }
            return '';
        },
        day() {
            return moment().format('YYYY-MM-DD');
        },
        today() {
            return moment().format('YYYY-MM-DD');
        },
        calExpEndDt() {
            // 변경 후 유효기간 종료일 계산
            return moment(this.expireEndDate).add(this.editField.expirePlusDay, 'days').format('YYYY-MM-DD');

            /*
      return moment(this.selectedExtendDetail.c_exp_end_dt)
          .add(this.editField.expirePlusDay, 'days')
          .format('YYYY-MM-DD');
       */
        },
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        // 유효기간 계산
        expireStartDate() {
            const { expireStartDt, orgExpireStartDt } = this.currentProduct;
            return !Utils.isEmpty(expireStartDt) ? expireStartDt : orgExpireStartDt;
        },
        expireEndDate() {
            const { expireEndDt, orgExpireEndDt } = this.currentProduct;
            return !Utils.isEmpty(expireEndDt) ? expireEndDt : orgExpireEndDt;
        },
        groupReservationLimitDate() {
            if (this.isAllowed('LE', 6)) {
                return moment(this.currentProduct.expireStartDt).format('YYYY-MM-DD');
            }

            if (Utils.isEmpty(this.reservationSetting.teacherReservationGr)) {
                return moment().format('YYYY-MM-DD');
            }

            const dtStr = this.reservationSetting.teacherReservationGr;
            const [day, hour, min] = dtStr.split('-');
            return moment().subtract(parseInt(day), 'days').format('YYYY-MM-DD');
        },
        loginId() {
            return this.$store.getters['auth/staffId'];
        },
    },
    watch: {
        startDate(newValue) {
            this.startDate = newValue;
        },
        expirePlusStaffId(newValue) {
            // 상담자
            this.expirePlusStaffId = newValue;
            // this.fetchExtendList();
        },
        centerStaffId(newValue) {},
    },
    data() {
        return {
            batchLoading: false,
            infoPop: false, // 그룹일괄예약 저장확인 팝업
            groupPop: false, // 그룹일괄예약 팝업
            periodPop: false, // 기간연장 팝업
            layerTab: 1, // 기간연장 팝업 탭 활성화
            overlapPop: false, // 중복예약 알림 팝업
            attendPop: false, // 출결 승인 팝업
            reservationPop: false, // 스케줄 예약 팝업
            batchReservationPop: false, // 그룹 스케줄 예약 팝업
            batchReservationPopNew: false, // 신규 스케줄 예약 팝업
            groupReservPop: false, // 스케줄 예약 팝업
            dateAsc: false, // 오름차순 여부
            total_cnt: 0,
            centerId: '',
            staffId: '',
            productIndex: 0,
            centerProductId: this.$route.query.centerProductId,
            centerStaffId: this.$store.state.auth.user.uid, // 센터 스태프 아이디
            centerCustomerId: this.$route.query.customerId,
            centerContractId: this.$route.query.contractId,
            centerLessonScheduleId: '', // 수업 아이디(개인,OT 등)
            joinSeq: '',
            searchList: [],
            calendarStaffId: '',

            extPeriodList: [], // 연장 히스토리 내역
            staffNameList: [], // 스태프 리스트
            staffValueList: [], // 스태프 아이디값.

            absentReason: '', // 결석 이유
            attendanceStatus: '', // 출석상태

            startDate: '',
            endDate: '',

            // 리스트
            roomList: [],
            roomValList: [],

            expPlusStaffList: [], // 상담자 이름 목록
            expPlusStaffValueList: [], // 상담자 값(id) 목록

            // 기간연장 관련 데이터
            editField: {
                expirePlusType: '-',
                expirePlusStartDt: '',
                expirePlusEndDt: '',
                expirePlusDay: '',
                expirePlusStaffId: '',
                expirePlusMemo: '',
            },

            selectedExtendDetail: {}, // 팝업에 보여질 선택한 연장기간 상세
            userInfo: {}, // 이용권 사용자 정보
            // pagingInfo: {
            //     ... this.pagingInfo,
            // },
            pagingInfo: { ...pagingInfo },
            roomId: '',

            step: 1,
            isModify: false,
            selectedRoom: null,
            lessonTimeAlertMsg: '',
            selectedTeacher: '',
            selectedCustomer: null,
            selectedContract: null,
            lessonDate: moment().format('YYYY-MM-DD'),
            selectFormCustomerProduct: {
                list: [],
                data: [],
                value: [],
                selectedValue: '',
            },
            selectFormStartTime: {
                data: [],
                value: [],
                selectedValue: '00:00',
            },
            selectFormEndTime: {
                data: [],
                value: [],
                selectedValue: '00:00',
            },
            selectFormStartHour: {
                data: [],
                value: [],
                selectedValue: '00',
            },
            selectFormStartMin: {
                data: [],
                value: [],
                selectedValue: '00',
            },
            selectFormLessonTime: {
                data: ['30분', '1시간', '1시간 30분', '2시간'],
                value: [30, 60, 90, 180],
                selectedValue: 60,
            },
            selectFormTeacher: {
                data: ['선택'],
                value: [''],
                selectedValue: '',
            },
            memo: '',
            rooms: [],
            selectFormRoom: [],
            reservationSetting: {},
            selectFormProduct: {
                data: [],
                value: [],
                selectedValue: '',
                list: [],
            },

            // 그룹레슨 달력
            prevYear: moment().subtract(1, 'months').format('YYYY-MM'),
            thisYear: moment().format('YYYY-MM'),

            // 그룹레슨 배열
            groupLesson: '',
            selectedGroupLesson: '',
            countCheckedCalendar: 0,

            // 그룹인지 여부 확인
            onGroup: false,
            // 그룹일괄예약에서 선택된 날짜들
            checkedCalendarLesson: [],
            timeValues: [],
            batchLesson: {},

            // 스케줄 예약상태 정보
            userAttendInfo: {},
            allLessonScheduleIds: [],

            // 기간연장
            periodPopProps: {},

            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],

            allLessonSchedule: [],

            mode: '',

            checkScheduleList: [], // 체크박스 선택한 회원 목록
            selectAll: false, // 전체 선택 해제

            centerContractBillTicketList: [], // 센터회원계약 이용권 결제 목록
            centerContractBillTicketNameList: [], // 센터회원계약 이용권 결제 목록 SelectBox Name
            centerContractBillTicketValueList: [], // 센터회원계약 이용권 결제 목록 SelectBox Value
            scheduleDate: null, // 달력
            selectedTicketList: [], // 선택된 이용권 리스트
            selectedTicketValueList: [], // 선택된 이용권 리스트
            duetCalendarStaffId: '',
            reservedScheduleList: [], // 이미 등록된 일정
            selectedScheduleList: [], // 선택한 일정
            selectedScheduleValueList: [], // 선택한 일정
            isLoading: false,
        };
    },
    mounted() {
        this.centerId = this.cId; // 센터 Id
        this.pagingInfo.page = 1;
        this.init();
    },
    methods: {
        toggleAsc() {
            this.dateAsc = !this.dateAsc;
            this.fetchLessonSchedules();
        },
        updateEditFieldReservCenterRoom(val, room, index) {
            const roomInfo = this.selectFormRoom[index].room[val];
            if (roomInfo && !roomInfo.reserveYn) {
                alert('현재 미사용중인 센터룸입니다.');
                return false;
            } else if (
                !this.batchReservationPop &&
                !this.batchReservationPopNew &&
                roomInfo.totalCount >= roomInfo.limitCount
            ) {
                alert('선택 할 수 없는 룸입니다.');
                return false;
            }
            this.selectedRoom = room;

            room.centerRoomId = val;
        },
        updateEditFieldReservCenterRoomNew(val, room, index) {
            const roomInfo = this.selectFormRoom[index].room[val];
            if (roomInfo && !roomInfo.reserveYn) {
                alert('현재 미사용중인 센터룸입니다.');
                return false;
            } else if (
                roomInfo &&
                this.ticketType === 'D' &&
                roomInfo.limitCount > 0 &&
                this.selectedTicketList.length + roomInfo.totalCount > roomInfo.limitCount
            ) {
                alert('선택 할 수 없는 룸입니다.');
                return false;
            }
            this.selectedRoom = room;

            room.centerRoomId = val;
        },
        selectRoom(index) {
            if (!Utils.isEmpty(this.selectFormRoom) && this.selectFormRoom.length > index) {
                return this.selectFormRoom[index];
            }
            return {
                data: ['선택 안함'],
                value: [''],
            };
        },
        async init() {
            this.staffId = parseInt(this.$store.getters['auth/staffId']);

            await this.fetchReservationSetting(); // 시간설정 가져오기
            await this.fetchCustomerContract(); // 유저정보 설정.

            await this.fetchAllLessonScheduleIds();
            await this.fetchLessonSchedules(); // 스케줄 예약 목록 가져오기.

            await this.onStaffList(); // 스태프리스트 호출
            await this.onSearchRoom(); // 룸
            await this.fetchCenterStaffList(); // 상담자 목록 가져오기
            await this.ticketProductList(); // 스케줄 예약 상품목록
            // await this.onGroupLessonList(); //그룹레슨
            await this.fetchCenterContractBillTicketList(); // 센터회원계약 이용권 결제 목록 조회

            const { selectFormStartHour, selectFormStartMin, selectFormStartTime, selectFormEndTime } = this;

            // 수업시작 시간 : 시
            for (let h = 0; h < 24; h++) {
                const hour = h.toString().padStart(2, '0');
                selectFormStartHour.data.push(hour);
                selectFormStartHour.value.push(hour);
            }
            // 수업시작 시간 : 분
            const timeUnitValue = this.reservationSetting.timeUnitValue;
            if (timeUnitValue < 60) {
                for (let m = 0; m < 60; m += timeUnitValue) {
                    const min = m.toString().padStart(2, '0');
                    selectFormStartMin.data.push(min);
                    selectFormStartMin.value.push(min);
                }
            } else {
                selectFormStartMin.data.push('00');
                selectFormStartMin.value.push('00');
            }
            // 수업시작 시간 : HH:mm
            for (let h = 0; h < 24; h++) {
                const timeHour = h.toString().padStart(2, '0');
                for (let m = 0; m < 60; m += timeUnitValue) {
                    const timeMin = m.toString().padStart(2, '0');
                    const time = `${timeHour}:${timeMin}`;
                    selectFormStartTime.data.push(time);
                    selectFormStartTime.value.push(time);
                }
            }
            const day = moment().day() == 0 ? 7 : moment().day();
            selectFormStartTime.selectedValue = eval(`this.reservationSetting.week${day}StartTime.substr(0,5)`);
            // 수업종료 시간 : HH:mm
            selectFormEndTime.selectedValue = moment(selectFormStartTime.selectedValue, 'HH:mm')
                .add(this.currentProduct.centerProduct.lessonTime, 'minutes')
                .format('HH:mm');
            selectFormEndTime.data.push(selectFormEndTime.selectedValue);
            selectFormEndTime.value.push(selectFormEndTime.selectedValue);
        },
        // 페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.fetchLessonSchedules();
        },
        // 스케줄 예약 목록 보기
        async fetchLessonSchedules() {
            try {
                const { data } = await this.getLessonSchedules();
                this.setPageParams(data);
                this.searchList = data.items;
                this.total_cnt = data.length === 0 ? 0 : data.meta.totalItems;
                this.checkScheduleList = [];
            } catch (error) {
                console.log(error);
            }
        },
        getLessonSchedules() {
            // @스웨거: 회원별 스케줄 예약 목록조회(페이징) API
            return api.get(
                `/admin/api/center/${this.centerId}/lesson/schedule/product/${this.centerProductId}/customer/${this.centerCustomerId}/contract/${this.centerContractId}`,
                {
                    params: {
                        ...this.pagingInfo,
                        sortType: this.dateAsc ? 'ASC' : 'DESC',
                        sortColumn: 'lessonDate',
                    },
                }
            );
        },
        async fetchAllLessonScheduleIds() {
            this.allLessonScheduleIds = [];
            try {
                const { data } = await this.getAllLessonSchedules();
                this.allLessonSchedule = [];
                this.allLessonSchedule.push(...data.items);
                for (const lesson of data.items) {
                    if (lesson.clsc_resv_status_cd === 'RR' || lesson.clsc_resv_status_cd === 'CR') {
                        this.allLessonScheduleIds.push(lesson.cls_center_less_schd_id);
                    }
                }
            } catch (error) {
                console.log(error);
            }
        },
        getAllLessonSchedules() {
            // 이미 예약된 모든 수업을 가져오기 위해 limit을 500으로 호출한다.
            // scheduleId만 배열로 저장한다.
            // 스웨거검색: 회원별 스케줄 예약 목록조회(페이징) API

            const pageInfo = {
                page: 1, // 페이지
                limit: 500, // 한 목록에 표출되는 건수
                totalItems: '', // 총 Item 수
                itemCount: '', // 현재 페이지 item 수
                totalPages: '', // 총 페이지 수
                route: '', // 링크 경로 생성시 프리픽스
            };

            // 2021.04.14, notbadlife@eb, deprecated API 이동
            // const url = `/admin/api/center/${this.centerId}/lesson/schedule/product/${this.centerProductId}/customer/${this.centerCustomerId}`;
            const url = `/admin/api/center/${this.centerId}/lesson/schedule/product/${this.centerProductId}/customer/${this.centerCustomerId}/contract/${this.centerContractId}`;

            return api.get(url, {
                params: {
                    ...pageInfo,
                },
            });
        },
        // 사용자정보
        async fetchCustomerContract() {
            try {
                const { data } = await this.getCustomerContract();

                this.selectedContract = data; // 오브젝트 사용자 정보값을 넣는다.
                this.selectedCustomer = data.centerCustomer;

                if (this.selectedContract.productType === 'P') {
                    // 패키지인 경우
                    let i = 0;
                    for (const centerProduct of this.selectedContract.centerContractProducts) {
                        if (centerProduct.centerProductId === this.centerProductId) {
                            this.productIndex = i;
                            break;
                        }
                        i++;
                    }

                    this.selectFormProduct.selectedValue = this.currentProduct.centerProductId;
                    this.centerProductId = this.currentProduct.centerProductId;
                }

                if (this.currentProduct.centerProduct.ticketType === 'G') {
                    this.onGroup = true;
                }
            } catch (error) {
                console.log(error);
            }
        },
        getCustomerContract() {
            // 스웨거검색: 센터회원계약 조회
            return api.get(
                `/admin/api/center/${this.centerId}/customer/${this.centerCustomerId}/contract/${this.centerContractId}`
            );
        },
        // 기간연장 관련(조회)
        async onExtPeriod() {
            try {
                const { data } = await this.getExtPeriod();
                this.extPeriodList = data.items;

                this.periodPop = true;
                this.layerTab = 2;

                this.initExtentionEditField();
            } catch (error) {
                console.log(error);
            }
        },
        // 연장내역 조회 api
        getExtPeriod() {
            const { centerCustomerId, centerContractId } = this;
            const searchParams = {
                startDate: moment().subtract(1, 'years').format('YYYYMMDD'),
                endDate: moment().format('YYYYMMDD'),
                centerCustomerId,
                centerContractId,
            };
            return api.get(`/admin/api/center/${this.centerId}/contract/extend`, {
                params: {
                    ...this.pagingInfo,
                    ...searchParams,
                },
            });
        },
        // 기간 연장 등록 버튼 클릭시
        async onPostExtPeriod() {
            if (!confirm('연장하시겠습니까?')) {
                return false;
            }

            try {
                await this.getPostExtPeriod();

                this.periodPop = false;
                this.editField = {
                    // 기간연장 등록 변수 초기화
                    expirePlusType: '-',
                    expirePlusStartDt: this.today,
                    expirePlusEndDt: null,
                    expirePlusDay: '',
                    expirePlusStaffId: parseInt(this.staffId),
                    expirePlusMemo: '',
                };

                this.init();
            } catch (error) {
                console.log(error);
            }
        },
        getPostExtPeriod() {
            // 스웨거검색: 센터회원 기간연장내역 저장/수정
            const params = this.getModifyParams(); // 가공된 파라미터
            return api.put(`/admin/api/center/${this.centerId}/contract/extend/${this.centerContractId}`, {
                ...params,
            });
        },
        // 기간연장 수정 파라미터 가공
        getModifyParams() {
            const {
                expirePlusType,
                expirePlusStartDt,
                expirePlusEndDt,
                expirePlusDay,
                expirePlusStaffId,
                expirePlusMemo,
            } = this.editField;

            const params = {
                expirePlusType,
                expirePlusStartDt,
                expirePlusEndDt,
                expirePlusDay,
                expirePlusStaffId,
                expirePlusMemo,
            };

            return params;
        },

        // 기간 연장 삭제 버튼 클릭시
        async onDeleteExtPeriod() {
            if (!confirm('기간 연장을 삭제하시겠습니까?')) {
                return false;
            }

            try {
                await this.getDeleteExtPeriod();

                this.periodPop = false;
                this.init();
            } catch (error) {
                Utils.alertResponseErrorMessge(error);
                console.log(error);
            }
        },
        // 기간 연장 삭제 API
        getDeleteExtPeriod() {
            // 스웨거 검색: 센터회원 기간연장내역 삭제
            return api.delete(
                `/admin/api/center/${this.centerId}/contract/extend/${this.centerContractId}/${this.extPeriodList[0].c_center_tick_exp_history_id}`
            );
        },
        // 스태프리스트 호출
        async onStaffList() {
            try {
                const { data } = await this.getStaffList();
                data.forEach((g) => {
                    this.staffNameList.push(g.name);
                    this.staffValueList.push(g.centerStaffId);
                });
                const obj = Utils.getSelectFormObjectFromArray('name', 'centerStaffId', data, '선택');
                this.selectFormTeacher.data = obj.data;
                this.selectFormTeacher.value = obj.value;
            } catch (error) {
                console.log(error);
            }
        },

        // 스태프 리스트 api
        getStaffList() {
            return api.get(`/admin/api/center/${this.centerId}/staff/teachers/list`);
        },
        // 스케줄 예약 출첵 처리
        async attendCheck(status) {
            this.isLoading = true;
            if (status === 'X' && Utils.isEmpty(this.absentReason.trim())) {
                alert('결석사유를 입력해주세요.');
                this.isLoading = false;
                return false;
            }
            // 비 그룹레슨인 경우 결석 처리
            if (status === 'X' && Utils.isEmpty(this.absentReason.trim()) == false && this.onGroup == false) {
                try {
                    await this.getAttendCheckNotGroup(); // 그룹레슨이 아닐때
                    await this.fetchLessonSchedules(); // 리스트 refresh
                    await this.fetchCustomerContract(); // 유저 정보 리프레쉬

                    alert('결석 처리가 완료되었습니다.');

                    this.attendPop = false; // 팝업 닫기
                    this.initAttendanceData();
                } catch (error) {
                    console.log(error);
                    return;
                }
            }
            // 그룹레슨인 경우 결석 처리
            if (status === 'X' && Utils.isEmpty(this.absentReason.trim()) == false && this.onGroup == true) {
                alert('그룹레슨 결석 처리');
                try {
                    await this.getAttendCheckGroup(); // 그룹레슨인 경우
                    await this.fetchLessonSchedules(); // 리스트 refresh
                    await this.fetchCustomerContract(); // 유저 정보 리프레쉬

                    alert('결석 처리가 완료되었습니다.');
                    this.isLoading = false;
                    this.attendPop = false; // 팝업 닫기
                    this.initAttendanceData();
                } catch (error) {
                    console.log(error);
                }
            } else {
                try {
                    await this.getAttendCheck(status);
                    await this.fetchCustomerContract(); // 유저 정보 리프레쉬
                    await this.fetchLessonSchedules(); // 리스트 refresh

                    alert('출석 승인이 되었습니다.');
                    this.isLoading = false;
                    this.attendPop = false; // 팝업 닫기
                    this.initAttendanceData();
                } catch (e) {
                    console.log(e);
                } finally {
                    this.isLoading = false;
                }
            }
        },
        // 스태프 예약 출첵처리 api
        getAttendCheck(status) {
            return api.put(
                `/admin/api/center/${this.centerId}/lesson/schedule/${this.centerLessonScheduleId}/customer/${this.centerCustomerId}/attendance-status`,
                {
                    joinSeq: this.joinSeq, // joinSeq도 설정해야 값이 제대로 적용됨.
                    attendanceStatus: status,
                    attendanceDevice: 'AW',
                    scheduleCancelReason: this.absentReason,
                }
            );
        },
        // 비 그룹레슨 결석처리
        getAttendCheckNotGroup() {
            return api.put(`/admin/api/center/${this.centerId}/lesson/schedule/absence-status`, {
                centerLessonScheduleId: this.centerLessonScheduleId,
                attendanceDevice: 'AW',
                centerCustomerIds: [this.centerCustomerId],
                lessonCustomerOffReason: this.absentReason,
            });
        },
        // 그룹레슨 결석 처리
        getAttendCheckGroup() {
            return api.put(`/admin/api/center/${this.centerId}/lesson/schedule/groupLessonAbsent/customers`, {
                centerId: this.centerId,
                centerLessonScheduleId: this.centerLessonScheduleId,
                attendanceDevice: 'AW',
                centerCustomerIds: [this.centerCustomerId],
                lessonCustomerOffReason: this.absentReason,
            });
        },
        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
            this.fetchLessonSchedules();
        },
        // 센터 룸 조회
        async onSearchRoom() {
            try {
                const { data } = await this.getSerachRoom();
                data.forEach((g) => {
                    this.roomList.push(g.name);
                    this.roomValList.push(g.centerRoomId);
                });
            } catch (error) {
                console.log(error);
            }
        },
        // 센터 룸 조회 api
        getSerachRoom() {
            return api.get(`/admin/api/centerRoom/${this.centerId}`);
        },
        // 출결취소
        async onAttendCancel(lessonId, joinSeq, customerId, status, s) {
            if (s.clsc_bill_status_cd == 'O') {
                alert('정산취소를 먼저 해주세요.');
                return false;
            }

            if (!confirm('출결 취소 하시겠습니까?')) {
                return false;
            }

            try {
                this.cenverLessonScheduleId = lessonId;
                this.centerCustomerId = customerId;
                this.joinSeq = joinSeq;
                const { data } = await this.getAttendCancel(status, joinSeq);

                alert('출결취소 되었습니다.');

                this.fetchLessonSchedules(); // 리스트 refresh
            } catch (error) {
                console.log(error);
            }
        },
        // 출결취소 API
        getAttendCancel(status) {
            // 스웨거 검색: 비 그룹레슨 출결승인
            return api.put(
                `/admin/api/center/${this.centerId}/lesson/schedule/${this.cenverLessonScheduleId}/customer/${this.centerCustomerId}/attendance-status`,
                {
                    joinSeq: this.joinSeq,
                    attendanceStatus: status,
                    attendanceDevice: 'AW',
                    scheduleCancelReason: '',
                }
            );
        },
        /* 사용하지 않는 코드 확인
    //그룹레슨 단건 등록
    async onGroupLessonPost() {
        try {
            const { data } = await this.getGroupLessonPost();
            console.log('그룹레슨이 등록되었습니다.',data)
        } catch (error) {
            console.log('aaa');
            console.log(error);
        }
    },
    //그룹레슨 단건 등록 API
    getGroupLessonPost() {
        return api.post(`/admin/api/center/${this.centerId}/lesson/schedule/group/addCustomer/${this.centerCustomerId}`,
            {
                centerContractId: this.centerContractId,
                centerProductId: this.centerProductId,
                centerCustomerName: this.selectedCustomer.name,
                reservationStatus: 'RR',
                reservationType: 'S',
                reservationId: this.centerStaffId,
                attendanceDevice: 'AW',
                centerLessonScheduleIds: [parseInt(this.selectedGroupLesson)],
            }
        );
    },
    */
        // 이용권 코드 변환
        convertTicketTypeFormat(type) {
            if (type === 'P') {
                return '[개인]';
            } else if (type === 'O') {
                return '[OT]';
            } else if (type === 'D') {
                return '[듀엣]';
            } else if (type === 'G') {
                return '[그룹]';
            } else if (type === 'C') {
                return '[쿠폰]';
            } else if (type === 'T') {
                return '[회원권]';
            } else if (type === 'S') {
                return '[운동복]';
            }
        },
        // 직원(상담자) 목록 가져오기
        async fetchCenterStaffList() {
            try {
                const { data } = await this.sendGetCenterStaffList();
                data.forEach((d) => {
                    this.expPlusStaffList.push(d.name);
                    this.expPlusStaffValueList.push(d.centerStaffId);
                });
            } catch (error) {
                alert('직원 목록을 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },
        // 직원 목록 API 호출
        sendGetCenterStaffList() {
            return api.get(`/admin/api/center/${this.centerId}/staff/all/list`);
        },
        // 기간연장 일괄등록 팝업에서 연장기간 시작일 변경시
        updateBundleExtendStartDt(val) {
            this.bundleExtendEditField.expirePlusStartDt = val;
            if (this.bundleExtendEditField.expirePlusEndDt !== null) {
                // 종료일이 선택되어 있으면
                const checkBeforeEndDt = moment(val).isSameOrBefore(this.bundleExtendEditField.expirePlusEndDt, 'day'); // 선택된 종료일 이전인지 체크
                if (checkBeforeEndDt === false) {
                    alert('종료일보다 이후 날짜입니다. 다시 선택하세요.');
                    this.bundleExtendEditField.expirePlusDay = 0;
                }

                const selectStartDt = moment(val, 'YYYY-MM-DD'); // 변경한 연장기간 시작일
                const selectEndDt = moment(this.bundleExtendEditField.expirePlusEndDt).startOf('day'); // 연장기간 종료일
                const diffDays = moment.duration(selectEndDt.diff(selectStartDt)).asDays(); // 연장기간 시작일~종료일 일수 계산
                if (diffDays < 0) {
                    alert('날짜를 다시 선택하세요.');
                    this.bundleExtendEditField.expirePlusDay = 0;
                } else {
                    this.bundleExtendEditField.expirePlusDay = diffDays;
                }
            }
        },
        // 기간연장 일괄등록 팝업에서 연장기간 종료일 변경시
        updateBundleExtendEndDt(val) {
            if (val === '' || val === undefined || val === null) {
                return;
            }

            const checkAfterStartDt = moment(val).isSameOrAfter(this.bundleExtendEditField.expirePlusStartDt, 'day'); // 선택된 시작일 이후인지 체크

            if (checkAfterStartDt === false) {
                this.bundleExtendEditField.expirePlusDay = 0;
                this.bundleExtendEditField.expirePlusEndDt = '';
                alert('시작일보다 이전 날짜입니다. 다시 선택하세요.');
            } else {
                const selectEndDt = moment(val, 'YYYY-MM-DD'); // 변경한 연장기간 종료일
                const selectStartDt = moment(this.bundleExtendEditField.expirePlusStartDt).startOf('day'); // 연장기간 시작일
                const diffDays = moment.duration(selectEndDt.diff(selectStartDt)).asDays(); // 연장기간 시작일~종료일 일수 계산
                if (diffDays < 0) {
                    alert('다시 선택하세요.');
                    this.bundleExtendEditField.expirePlusDay = 0;
                } else {
                    this.bundleExtendEditField.expirePlusDay = diffDays;
                    this.bundleExtendEditField.expirePlusEndDt = val;
                }
            }
        },
        calculateExpirePlusDay() {
            // 연장시작일자/연장종료일자로 연장일수 계산
            const { expirePlusStartDt, expirePlusEndDt } = this.editField;
            if (Utils.isEmpty(expirePlusStartDt) || Utils.isEmpty(expirePlusEndDt)) {
                return false;
            }

            const dFormat = 'YYYY-MM-DD';
            const diffDays = moment(expirePlusEndDt, dFormat).diff(moment(expirePlusStartDt, dFormat), 'days');

            this.editField.expirePlusDay = diffDays + 1;

            /*
      let endDt = moment(this.editField.expirePlusEndDt, 'YYYY-MM-DD'); // 변경한 연장기간 종료일
      let startDt = moment(this.selectedExtendDetail.c_exp_end_dt).startOf('day'); // 현재 유효기간 종료일
      let diffDays = moment
          .duration(curExpEndDt.diff(curExpStartDt))
          .asDays(); // 현재 유효기간 종료일 ~ 연장하는 유효기간 종료일 차이를 구함
      this.editField.expirePlusEndDt = val;
      this.editField.expirePlusDay = diffDays;
      */
        },
        // 유효기간 연장 기간 시작일 변경시
        updateExpStartDt(date) {
            // 현재 유효기간 이내 여부 체크
            if (moment(date).isBefore(this.expireStartDate)) {
                alert('현재 유효기간 내에서 선택하세요.');
                this.editField.expirePlusStartDt = this.expireStartDate;
            }
            /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              else if(moment(date).isAfter(this.expireEndDate)) {
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  alert("현재 유효기간 내에서 선택하세요.");
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  this.editField.expirePlusStartDt = this.expireEndDate;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              }
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
            // 연장 종료날짜보다 큰 경우
            else if (
                !Utils.isEmpty(this.editField.expirePlusEndDt) &&
                moment(date).isAfter(this.editField.expirePlusEndDt)
            ) {
                alert('종료날짜보다 이후날짜를 선택할 수 없습니다.');
                this.editField.expirePlusStartDt = this.editField.expirePlusEndDt;
            } else {
                this.editField.expirePlusStartDt = date;
            }

            this.calculateExpirePlusDay();
        },

        // 유효기간 연장 기간 종료일 변경시
        updateExpEndDt(date) {
            // 현재 유효기간 이내 여부 체크
            if (moment(date).isBefore(this.expireStartDate)) {
                alert('현재 유효기간 내에서 선택하세요.');
                this.editField.expirePlusEndDt = this.expireStartDate;
            }
            /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              else if(moment(date).isAfter(this.expireEndDate)) {
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  alert("현재 유효기간 내에서 선택하세요.");
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  this.editField.expirePlusEndDt = this.expireEndDate;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              }
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
            // 연장 시작날짜보다 작은 경우
            else if (
                !Utils.isEmpty(this.editField.expirePlusStartDt) &&
                moment(date).isBefore(this.editField.expirePlusStartDt)
            ) {
                alert('시작날짜보다 이전날짜를 선택할 수 없습니다.');
                this.editField.expirePlusEndDt = this.editField.expirePlusStartDt;
            } else {
                this.editField.expirePlusEndDt = date;
            }

            this.calculateExpirePlusDay();
        },
        // 연장 일수 입력시
        onInputExpPlusDay() {
            if (Utils.isEmpty(this.editField.expirePlusDay)) {
                return false;
            }

            if (this.editField.expirePlusDay < 1) {
                this.editField.expirePlusDay = 1;
            }

            const dFormat = 'YYYY-MM-DD';
            this.editField.expirePlusEndDt = moment(this.editField.expirePlusStartDt, dFormat)
                .add(this.editField.expirePlusDay - 1, 'days')
                .format(dFormat);
        },
        // 연장기간 링크 클릭시
        onClickExtendDetail(selectedExtendDetail, layerTabNumber) {
            this.periodPopProps = {
                customerName: this.customerName,
                layerTabNumber,
                selectedExtendDetail,
                expPlusStaffList: this.expPlusStaffList,
                expPlusStaffValueList: this.expPlusStaffValueList,
                centerId: this.centerId,
                centerContractId: this.centerContractId,
                centerStaffId: this.centerStaffId,
            };

            this.periodPop = true;
            // this.layerTab = 1;
            // this.selectedExtendDetail = this.currentProduct;
            // console.log(this.selectedExtendDetail);

            // this.initExtentionEditField();
        },
        initExtentionEditField() {
            const now = moment().format('YYYY-MM-DD');
            let expirePlusStartDt = now;

            if (moment(expirePlusStartDt).isBefore(this.expireStartDate)) {
                expirePlusStartDt = this.expireStartDate;
            } else if (moment(expirePlusStartDt).isAfter(this.expireEndDate)) {
                expirePlusStartDt = this.expireEndDate;
            }

            this.editField = {
                expirePlusType: 'N',
                expirePlusStartDt,
                expirePlusEndDt: '',
                expirePlusDay: '',
                expirePlusStaffId: parseInt(this.centerStaffId),
                expirePlusMemo: '',
            };
        },
        // 숫자만 입력 감지
        isNumber(evt) {
            evt = evt || window.event;
            const charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        // 페이징 Param 설정
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
        // 출결현황 관련 api
        async onAttendCheck(s, lessId, joinSeq, customerId) {
            try {
                this.userAttendInfo = s;
                this.centerLessonScheduleId = lessId;
                this.centerCustomerId = customerId;
                this.joinSeq = joinSeq;
                this.attendPop = true;
            } catch (error) {
                console.log(error);
            }
        },
        /*
    updateReserveHour(hour) {
        this.editFieldReserv.selectFormStartHour.selectedValue = hour;
        if (this.checkReserveTime()) {
            this.checkLessonScheduleDuplicate();
        }
    },
    updateReserveMin(min) {
        this.editFieldReserv.selectFormStartMin.selectedValue = min;
    },
     */
        // 시간제한에 대한 설정
        getCenterReservSetting() {
            return api.get(`/admin/api/center/${this.centerId}/reservation-setting`);
        },
        // 강사이름 설정
        updateEditFieldReservSelectedTeacher(val) {
            this.selectedTeacher = val;
            this.onGroupLessonList(); // 그룹레슨 강사 목록 리스트 재조회
        },
        // 시간설정
        async fetchReservationSetting() {
            const { data } = await this.getCenterReservSetting();
            this.reservationSetting = data;
        },
        updateReserveHour(hour) {
            this.selectFormStartHour.selectedValue = hour;
            this.setupRoom();
        },
        updateReserveMin(min) {
            this.selectFormStartMin.selectedValue = min;
            this.setupRoom();
        },
        updateReserveStartTime(time) {
            this.selectFormStartTime.selectedValue = time;
            this.selectFormLessonTime.selectedValue = this.currentProduct.centerProduct.lessonTime;
            this.selectFormEndTime.selectedValue = moment(time, 'HH:mm')
                .add(this.currentProduct.centerProduct.lessonTime, 'minutes')
                .format('HH:mm');
            this.selectFormEndTime.data = [];
            this.selectFormEndTime.value = [];
            this.selectFormEndTime.data.push(this.selectFormEndTime.selectedValue);
            this.selectFormEndTime.value.push(this.selectFormEndTime.selectedValue);
            this.reservedScheduleList = [];
        },
        // 수업시간 변경
        convertLessonTime(time) {
            if (time == '30') {
                return '30분';
            } else if (time == '60') {
                return '1시간';
            } else if (time == '90') {
                return '1시간 30분';
            } else if (time == '120') {
                return '2시간';
            } else if (time == '180') {
                return '3시간';
            }
        },
        updateLessonDate(date) {
            this.lessonDate = date;
        },
        convertPlusType(type) {
            if (type == 'N') {
                return '연장';
            } else if (type == 'H') {
                return '홀딩';
            }
        },
        // 수정버튼 클릭시
        onEditExtPeriod(index) {
            this.layerTab = 1;
            this.selectedExtendDetail = this.selectedContract.centerContractProducts[index];
            const ef = {
                expirePlusType: this.selectedExtendDetail.expirePlusType,
                expirePlusStartDt: this.selectedExtendDetail.expireStartDt,
                expirePlusEndDt: this.selectedExtendDetail.expireEndDt,
                expirePlusDay: this.selectedExtendDetail.expirePlusDay,
                expirePlusStaffId: parseInt(this.selectedExtendDetail.expirePlusStaffId),
                expirePlusMemo: this.selectedExtendDetail.expirePlusMemo,
            };
            this.editField = ef;
        },
        // 스케줄 예약 상품목록
        async ticketProductList() {
            try {
                if (this.selectedContract.productType === 'P') {
                    for (const centerContractProduct of this.selectedContract.centerContractProducts) {
                        const { centerProduct } = centerContractProduct;
                        const ticketTypeName = Utils.getTicketTypeName(centerProduct.ticketType);
                        this.selectFormProduct.data.push(`[${ticketTypeName}] ${centerProduct.name}`);
                        this.selectFormProduct.value.push(centerProduct.centerProductId);
                    }
                }
                // else if( this.currentProduct.centerProduct.ticketType == 'G' ){
                else {
                    this.selectFormProduct.data.push(
                        `${this.convertTicketTypeFormat(this.currentProduct.centerProduct.ticketType)} ${
                            this.currentProduct.productName
                        }`
                    );
                    this.selectFormProduct.value.push('1');
                    this.selectFormProduct.selectedValue = '1';
                }
                /*
        else {
            const { data } = await this.getTicketProductList();
            this.selectFormProduct.list = [];
            data.forEach((g) => {
                this.selectFormProduct.data.push(this.convertTicketTypeFormat(g.centerProduct.ticketType) + ` ${g.centerProduct.name}`);
                this.selectFormProduct.value.push(g.centerProductId);

                this.selectFormProduct.list.push(
                    g.centerContractId
                );
            });
            this.selectFormProduct.selectedValue = this.centerProductId;
        }
        */
            } catch (error) {
                console.log(error);
            }
        },
        getTicketProductList() {
            return api.get(`/admin/api/center/${this.centerId}/customer/ticketList/notGroup/${this.centerCustomerId}`);
        },
        selectGroupLesson(val) {
            this.selectedGroupLesson = val;
        },
        async onCalendar() {
            this.calendarStaffId = this.teacherId;
            try {
                const dateStart = moment(this.currentProduct.expireStartDt);
                const dateEnd = moment(this.currentProduct.expireEndDt);

                this.checkedCalendarLesson = [];
                this.timeValues = []; // 초기화
                while (dateEnd > dateStart || dateStart.format('M') === dateEnd.format('M')) {
                    this.timeValues.push(dateStart.format('YYYY-MM'));
                    dateStart.add(1, 'month');

                    // 선택된 값을 받을 데이터 초기화
                    this.checkedCalendarLesson.push([]);
                }

                if (this.isDisableSelectStaffs) {
                    this.calendarStaffId = this.loginId;
                }

                this.groupPop = true;

                setTimeout(() => {
                    this.onUpdateMonth('', this.timeValues.findIndex(t => this.today.startsWith(t)))
                }, 800);
            } catch (error) {
                console.log(error);
            }
        },
        async onLessonBatch() {
            try {
                if (this.batchLesson.length === 0) {
                    alert('선택한 스케줄이 없습니다.');
                    return false;
                }
                // if (!this.selectedRoom) {
                //     alert('선택한 룸이 없습니다.');
                //     return false;
                // }
                if (this.batchLoading) alert('일괄 예약 진행 중입니다.');
                let cnt = 0;
                this.batchLoading = true;
                let error = false;
                for (const les1 of Object.values(this.batchLesson)) {
                    for (const les of les1) {
                        const dtFormat = 'YYYY-MM-DD HH:mm:ss';
                        const lessonStartTime = `${les.date} ${les.tm}:00`;
                        const lessonEndTimeMoment = moment(lessonStartTime, dtFormat).add(
                            this.currentProduct.centerProduct.lessonTime,
                            'minutes'
                        );

                        const lessonEndTime = lessonEndTimeMoment.format(dtFormat);
                        const centerLessonScheduleMasterId = this.isModify ? this.centerLessonScheduleMasterId : 0;

                        if (!Utils.isEmpty(this.selectedProduct)) {
                            // 이 값이 셋팅되어있으면, 이용권명을 보여주지 않는다. (수업>수업관리>등록에서 사용)
                            this.isFixedContract = true;
                            this.selectFormLessonTime.selectedValue = this.selectedProduct.centerProduct.lessonTime;
                        } else if (
                            !Utils.isEmpty(this.selectedCustomer.id) &&
                            !Utils.isEmpty(this.centerLessonScheduleId)
                        ) {
                            const { data: contractData } = await this.getDailyScheduleCustomerContract(
                                this.selectedCustomer.id,
                                this.centerLessonScheduleId
                            );

                            let productIndex = 0;
                            for (const product of this.selectFormCustomerProduct.list) {
                                if (
                                    product.centerProductId === contractData.centerProductId &&
                                    product.centerContractId === contractData.centerContractId
                                ) {
                                    this.selectedProduct = product;
                                    this.selectFormCustomerProduct.selectedValue = productIndex;
                                    break;
                                }
                                productIndex++;
                            }
                        }

                        const params = {
                            centerLessonScheduleMasterId,
                            reservationDevice: 'AW', // 등록 디바이스 고정값 (관리자웹 [ 관리자웹 : AW, 관리자앱 : AA, 회원앱 : CA, 터치모니터 : TU ])
                            reservationType: 'S', // 등록 주체 구분 고정값 ([직원 : S, 회원 : M])
                            reservationId: this.staffId, // 등록자 아이디
                            // centerContractId: this.selectedProduct.centerContractId,
                            // centerProductId: this.selectedProduct.centerProductId,
                            centerCustomerName: this.selectedCustomer.name,
                            lessonStaffId: this.calendarStaffId,
                            dayOfWeek: Utils.getDayOfWeekName(this.lessonDate),
                            lessonDate: les.date,
                            lessonStartTime: lessonStartTime.split(' ')[1],
                            lessonEndTime: lessonEndTime.split(' ')[1],
                            lessonsType: this.ticketType,
                            memo: '',
                            roomInfos: [],
                            centerProductId: this.centerProductId,
                            centerContractId: this.centerContractId,
                        };

                        // for (const r of this.rooms) {
                        //     if (!Utils.isEmpty(r.centerRoomId)) {
                        //         params.roomInfos.push(this.selectedRoom);
                        //     }
                        // }
                        if (this.selectedRoom) {
                            try {
                                const tRoom0 = { ...this.selectedRoom };
                                const tRoom1 = { ...this.selectedRoom };

                                // eslint-disable-next-line prefer-destructuring
                                tRoom0.useStartTime = lessonStartTime.split(' ')[1];
                                const halfTm = lessonEndTimeMoment
                                    .subtract(30, 'minute')
                                    .format(dtFormat)
                                    .split(' ')[1];
                                tRoom0.useEndTime = halfTm;
                                tRoom1.useStartTime = halfTm;
                                // eslint-disable-next-line prefer-destructuring
                                tRoom1.useEndTime = lessonEndTime.split(' ')[1];
                                params.roomInfos.push(tRoom0);
                                params.roomInfos.push(tRoom1);
                            } catch (e) {}
                        }

                        try {
                            await api.post(
                                `/admin/api/center/${this.centerId}/lesson/schedule/0/customer/${this.centerCustomerId}`,
                                { ...params }
                            );
                            cnt += 1;
                        } catch (e) {
                            error = true;
                            // console.log(JSON.stringify(e));
                            alert(`[${les.date}] ${e.response.data.message}`);
                            // Utils.alertResponseErrorMessge(e);
                        }
                    }
                }
                alert(`총 ${cnt}건이 예약되었습니다.`);
                this.batchLoading = false;

                if (error) {
                    this.onClickBtnLessonBatchReservation();
                    return;
                }

                this.onCloseCalendar();
                this.infoPop = cnt > 0;
            } catch (error) {
                Utils.alertResponseErrorMessge(error);
                console.log(error);
            }
        },

        // 그룹레슨 스케줄 일괄 등록하기
        async onGroupLessonBatch() {
            try {
                const centerLessonScheduleIds = this.getGroupLessonBatchParams();
                if (!centerLessonScheduleIds || centerLessonScheduleIds.length === 0) {
                    alert('선택한 스케줄이 없습니다.');
                    return;
                }

                await this.getGroupLessonBatch(centerLessonScheduleIds);

                this.onCloseCalendar();
                this.infoPop = true;
            } catch (error) {
                console.error(error);
                Utils.alertResponseErrorMessge(error);
            }
        },

        // 그룹레슨 일괄등록
        getGroupLessonBatch(centerLessonScheduleIds) {
            const { centerContractId, centerProductId, customerName: centerCustomerName } = this;

            // 스웨거 검색: 그룹수업 스케줄 일괄 예약하기
            return api.post(
                `/admin/api/center/${this.centerId}/lesson/schedule/group/customer/${this.centerCustomerId}`,
                {
                    centerContractId,
                    centerProductId,
                    centerCustomerName,
                    centerLessonScheduleIds,
                    reservationStatus: 'RR',
                    reservationType: 'S',
                    reservationId: this.centerStaffId,
                    reservationDevice: 'AW',
                }
            );
        },
        getGroupLessonBatchParams() {
            const centerLessonScheduleIds = [];

            for (const schdIds of this.checkedCalendarLesson) {
                for (const schdId of schdIds) {
                    centerLessonScheduleIds.push(schdId.cls_center_less_schd_id);
                }
            }

            return centerLessonScheduleIds;
        },
        onUpdateCheckBatchLessonReserve(add, lessonList, date, f) {
            if (
                add &&
                (Object.values(this.batchLesson).length
                    ? Object.values(this.batchLesson).reduce((a, b) => [...a, ...b]).length
                    : 0) >=
                    this.currentProduct.lessonCount - this.total_cnt
            ) {
                alert('남은 횟수보다 체크를 더 할 수 없습니다.');
                f();
                return;
            }

            this.batchLesson[date] = lessonList;
            this.batchLesson = { ...this.batchLesson };
        },

        onUpdateCheckLessonReserve(scheduleIds, seq, selectedLessons, lessonDate, schdId, reservedSchedules) {
            // 달력에서 설정한 배열

            const lessonCount = this.currentProduct.lessonCount;
            const lessonCountType = this.currentProduct.lessonCountType;

            let reservedLessonCount = 0;
            let selectedLessonCount = 0;

            this.checkedCalendarLesson[seq] = selectedLessons;

            this.countCheckedCalendar = 0;

            for (const ids of this.checkedCalendarLesson) {
                this.countCheckedCalendar += ids.length;
            }

            if (lessonCountType === 'T') {
                selectedLessonCount = this.countCheckedCalendar;
                reservedLessonCount = this.searchList.filter((lesson) => {
                    if (lesson.clsc_resv_status_cd === 'RR' || lesson.clsc_resv_status_cd === 'CR') {
                        return true;
                    }
                    return false;
                }).length;
            } else if (lessonCountType === 'W') {
                const test = [];
                const assign = {};
                // 선택한 수업의 날자를 테스트에 담는다.
                for (let i = 0; i < this.checkedCalendarLesson.length; i++) {
                    for (let j = 0; j < this.checkedCalendarLesson[i].length; j++) {
                        test.push({
                            cls_less_dt: moment(this.checkedCalendarLesson[i][j].cls_less_dt).format('YYYY-MM-DD'),
                        });
                    }
                }
                // 선택한 수업의 날짜를 확인한다.
                console.log(test);
                // 예약한 정보를 변수에 담는다.
                const arr = [...reservedSchedules];
                // 예약된 수업의 일자 + 선택한 수업의 날짜 더하기
                arr.push(...test);
                // 담겨진 변수를 확인한다.
                console.log(arr);
                // 두 예약 수업 정보를 하나씩 검증한다..
                // 검증 후 선택한 수업의 날짜를 확인하여 그 날짜의 주의 시작과 끝을 찾는다.
                // json 데이터의 특성을 사용하여, map과 같은 형식으로 데이터를 할당한다.
                for (let i = 0; i < arr.length; i++) {
                    // 시작날짜
                    const test = moment(arr[i].cls_less_dt).startOf('isoweek').format('YYYY-MM-DD');
                    // 끝 날짜.
                    const test2 = moment(test).add(6, 'days').format('YYYY-MM-DD');
                    assign[test] = 'sd';
                    assign[test2] = 'ed';
                }
                // 만든 json 값을 확인한다.
                console.log('assign', assign);
                // json의 키값이 곧 예약한, 또는 선택한 수업의 시작일, 끝일로 확인된다.

                // 해당 변수에 주의 시작일, 끝일을 담는다.
                const tempArr = Object.keys(assign);
                // 반복문을 돌려 선택한, 예약한 날짜가 전체 선택, 또는 예약된 수업의 시작일과 끝일안에 있는지 판단한다.
                for (let i = 0; i * 2 < tempArr.length; i++) {
                    // 배열의 순서 짝수 = 시작일
                    // 배열의 순서 홀수 = 끝일
                    console.log(tempArr[i * 2], tempArr[i * 2 + 1]);
                    // 시작일, 끝일에 포함될 경우 해당변수에 1씩 더한다.
                    selectedLessonCount = 0;
                    // 반복문으로 확인.
                    for (let j = 0; j < arr.length; j++) {
                        // console.log(arr[j].cls_less_dt,arr[j].cls_less_dt);
                        // 삼항 연산자로 계산.
                        selectedLessonCount +=
                            moment(arr[j].cls_less_dt).isSameOrAfter(tempArr[i * 2]) &&
                            moment(arr[j].cls_less_dt).isSameOrBefore(tempArr[i * 2 + 1])
                                ? 1
                                : 0;
                    }
                    console.log(selectedLessonCount);
                    // 만약 시작일, 끝일에 포함된 수업이 주 횟수보다 클 경우 반복문을 깬다.
                    if (selectedLessonCount > lessonCount) {
                        break;
                    }
                }
            } else {
                return;
            }

            if (selectedLessonCount + reservedLessonCount > lessonCount) {
                alert('수업 횟수가 초과되었습니다.');
                this.checkedCalendarLesson[seq] = selectedLessons.filter(
                    (lesson) => lesson.cls_center_less_schd_id !== schdId
                );

                this.countCheckedCalendar = 0;
                for (const ids of this.checkedCalendarLesson) {
                    this.countCheckedCalendar += ids.length;
                }

                const groupReserveTables = this.$refs.groupReserveTable;

                for (const groupReserveTable of groupReserveTables) {
                    groupReserveTable.arrangeCheckLessons(schdId);
                }
            }
        },
        async payApproval(lessId, custId, contractId) {
            if (!confirm('정산 처리하시겠습니까?')) {
                return false;
            }

            try {
                await this.getPayApproval(lessId, custId, contractId);
                alert('정산처리 되었습니다.');
                this.fetchLessonSchedules();
            } catch (error) {
                console.log(error);
            }
        },
        getPayApproval(lessId, custId, contractId) {
            // 스웨거 검색: 수업및정산 일괄정산 처리
            return api.put(`/admin/api/center/${this.centerId}/lesson/calculate/calculate`, {
                infos: [
                    {
                        centerLessonScheduleId: lessId,
                        centerCustomerId: custId,
                        centerContractId: contractId,
                    },
                ],
            });
        },
        async payCancel(lessId, custId) {
            if (!confirm('정산 취소하시겠습니까?')) {
                return false;
            }

            try {
                await this.getPayCancel(lessId, custId);
                this.init();
            } catch (error) {
                console.log(error);
            }
        },
        // 정산취소API
        getPayCancel(lessId, custId) {
            return api.put(`/admin/api/center/${this.centerId}/lesson/calculate/${lessId}/customer/${custId}/cancel`);
        },
        convertBillTime(time) {
            if (time === null || time === '' || time === undefined) {
                return time;
            }
            return moment(time).format('(MM.DD HH:mm)');
            // let result = moment(time).format('MM.DD HH:MM');
            // return '('+ result +')' ;
        },
        getRoomInfos(roomInfos) {
            if (Utils.isEmpty(roomInfos)) {
                return [];
            }

            const result = [];
            const roomList = roomInfos.split('|');

            for (const room of roomList) {
                const info = room.split(',');
                result.push({
                    name: info[0],
                    startTime: info[1],
                    endTime: info[2],
                });
            }
            return result;
        },
        onClickBtnCancelGroupReservation() {
            this.groupReservPop = false;

            this.$refs.groupReservationDlg.hide();
            this.$refs.groupReservationDlg.resetData();
        },
        onClickBtnCancelReservation() {
            this.reservationPop = false;
            this.batchReservationPop = false;
            this.batchReservationPopNew = false;

            this.$refs.lessonReservationDlg.hide();
            this.$refs.lessonReservationDlg.resetData();

            // 듀엣 일괄등록 모달 초기화
            this.duetCalendarStaffId = '';
            if (this.selectedTicketList.length > 1) {
                this.selectedTicketList.pop();
                this.selectedTicketValueList.pop();
            }
            this.selectedScheduleList = [];
            this.selectedScheduleValueList = [];
        },
        async onClickBtnLessonReservation() {
            const selectedTeacher = !this.teacherId ? this.staffId : this.teacherId;

            const preset = {
                selectedTeacher,
                selectedCustomer: {
                    id: this.selectedCustomer.centerCustomerId,
                    name: this.selectedCustomer.name,
                },
                selectedProduct: this.currentProduct,
            };

            await this.$refs.lessonReservationDlg.setPresetData(preset);

            this.reservationPop = true;
            this.$refs.lessonReservationDlg.show();
        },
        getCenterRoomReservation(useStartTime, useEndTime) {
            const { centerId, lessonDate } = this;
            // 스웨거 검색: 룸 예약 현황 조회
            return api.get(`/admin/api/centerRoom/reservation/status`, {
                params: {
                    centerId,
                    lessonDate,
                    useStartTime,
                    useEndTime,
                },
            });
        },
        async fetchSelectFormCenterRoom(useStartTime, useEndTime, index) {
            const { data } = await this.getCenterRoomReservation(useStartTime, useEndTime);

            const obj = {
                data: [],
                value: [],
            };

            const roomsMap = {};
            for (const item of data) {
                let title = item.name;
                if (!item.reserveYn) {
                    // title = `${title} (미사용)`;
                    continue;
                } else if (item.limitYn && !Utils.isEmpty(item.totalCount)) {
                    title = this.batchReservationPop ? title : `${title} (${item.totalCount}/${item.limitCount})`;
                }

                obj.data.push(title);
                obj.value.push(item.centerRoomId);
                roomsMap[item.centerRoomId] = item;
            }

            this.selectFormRoom[index] = {
                data: ['선택 안함', ...obj.data],
                value: ['', ...obj.value],
                room: { ...roomsMap },
            };
        },
        async setupRoom() {
            const dtFormat = 'YYYY-MM-DD HH:mm:ss';
            const tmFormat = 'HH:mm';
            const { lessonDate, selectFormStartHour, selectFormStartMin, selectFormLessonTime } = this;

            if (
                Utils.isEmpty(lessonDate) ||
                Utils.isEmpty(selectFormStartHour.selectedValue) ||
                Utils.isEmpty(selectFormStartMin.selectedValue)
            ) {
                return;
            }
            const lessonStartTime = moment(
                `${lessonDate} ${selectFormStartHour.selectedValue}:${selectFormStartMin.selectedValue}:00`,
                dtFormat
            );
            const len = selectFormLessonTime.selectedValue / 60;

            this.selectFormRoom = [];
            this.rooms = [];

            for (let i = 0; i < len; i++) {
                const useStartTime = lessonStartTime.format(tmFormat);
                const useEndTime = lessonStartTime.add(30, 'minute').format(tmFormat);
                this.selectFormRoom.push({
                    data: [],
                    value: [],
                });

                // eslint-disable-next-line no-await-in-loop
                await this.fetchSelectFormCenterRoom(useStartTime, useEndTime, i);

                this.rooms.push({
                    centerRoomId: '',
                    useStartTime,
                    useEndTime,
                });
            }

            // 기존 센터룸예약 정보 입력
            if (!Utils.isEmpty(this.presetRooms)) {
                const roomResvMap = this.presetRooms.reduce((acc, it) => ({ ...acc, [it.useStartTime]: it }), {});
                for (let i = 0; i < this.rooms.length; i++) {
                    const room = this.rooms[i];
                    if (
                        !Utils.isEmpty(roomResvMap[room.useStartTime]) &&
                        roomResvMap[room.useStartTime].lessonDate == this.lessonDate
                    ) {
                        room.centerRoomId = roomResvMap[room.useStartTime].centerRoomId;
                    }
                }
            }

            // this.fetchCenterRooms();
        },
        async onClickBtnLessonBatchReservation() {
            const selectedTeacher = this.teacherId;

            const preset = {
                selectedTeacher,
                selectedCustomer: {
                    id: this.selectedCustomer.centerCustomerId,
                    name: this.selectedCustomer.name,
                },
                selectedProduct: this.currentProduct,
            };

            this.batchReservationPop = true;
            this.selectedRoom = null;
            this.selectFormStartHour.selectedValue = '00';
            this.selectFormStartMin.selectedValue = '00';
            this.batchLesson = [];
            this.calendarStaffId = '';
            await this.setupRoom();
            // this.$refs.batchReserveTable.show();

            this.calendarStaffId = this.teacherId;
            try {
                const dateStart = moment(this.currentProduct.expireStartDt);
                const dateEnd = moment(this.currentProduct.expireEndDt);

                this.checkedCalendarLesson = [];
                this.timeValues = []; // 초기화
                while (dateEnd > dateStart || dateStart.format('M') === dateEnd.format('M')) {
                    this.timeValues.push(dateStart.format('YYYY-MM'));
                    dateStart.add(1, 'month');

                    // 선택된 값을 받을 데이터 초기화
                    this.checkedCalendarLesson.push([]);
                }
            } catch (error) {
                console.log(error);
            }
        },

        async onClickBtnGroupReservation() {
            const selectedTeacher = this.teacherId;
            const preset = {
                selectedTeacher,
                selectedCustomer: {
                    id: this.selectedCustomer.centerCustomerId,
                    name: this.selectedCustomer.name,
                },
                selectedProduct: this.currentProduct,
            };

            await this.$refs.groupReservationDlg.setPresetData(preset);

            this.groupReservPop = true;
            this.$refs.groupReservationDlg.show();
        },
        onCancelLessonReservationDlg() {
            this.reservationPop = false;
            this.batchReservationPop = false;
            this.batchReservationPopNew = false;
            this.$refs.lessonReservationDlg.resetData();
        },
        onSuccessLessonReservationDlg() {
            if (this.reservationPop) {
                this.fetchLessonSchedules();
                this.reservationPop = false;
                this.$refs.lessonReservationDlg.resetData();
            } else {
                this.batchReservationPop = false;
                this.batchReservationPopNew = false;
                // this.$refs.lessonReservationDlg.resetData();
            }
        },
        onCancelGroupReservationDlg() {
            this.groupReservPop = false;
            this.$refs.groupReservationDlg.resetData();
        },
        onSuccessGroupReservationDlg() {
            this.fetchLessonSchedules();
            this.groupReservPop = false;
            this.$refs.groupReservationDlg.resetData();
        },
        checkTeacherReservDatetime(date, time = '') {
            if (this.isAllowed('LE', 6)) {
                // 권한 여부 우선 체크
                return true;
            }

            // 기본값 셋팅
            const now = moment();
            let dFormat = 'YYYY-MM-DD';
            date = moment(date).format(dFormat);

            let reservDate = moment(date, dFormat);

            if (!Utils.isEmpty(time)) {
                time = Utils.getHourMinutes(time);
                reservDate = `${date} ${time}:00`;
                dFormat = `${dFormat} HH:mm:ss`;
            }

            // 오늘 이후 이면
            if (moment(reservDate, dFormat).isSame(now) || moment(reservDate, dFormat).isAfter(now)) {
                return true;
            }

            // 예약 가능 설정
            const { ticketType } = this;
            let dtStr = '';
            switch (ticketType) {
                case 'P':
                    dtStr = this.reservationSetting.teacherReservationCp;
                case 'O':
                    dtStr = this.reservationSetting.teacherReservationOt;
                    break;
                case 'D':
                    dtStr = this.reservationSetting.teacherReservationDu;
                    break;
                case 'G':
                    dtStr = this.reservationSetting.teacherReservationGr;
                    break;
            }

            if (Utils.isEmpty(dtStr)) {
                // 설정이 되어있지 않으면
                return true;
            }

            // 날짜 체크. 이전 날짜이면 예약 불가
            // 에약 가능한 최대 날짜 산출
            const [day, hour, min] = dtStr.split('-');
            // 0일 0시 0분으로 세팅되어 있으면 그냥 통과 시킨다.
            if (day == 0 && hour == 0 && min == 0) {
                return true;
            }

            const limitDate = moment().subtract(parseInt(day), 'days');
            if (!Utils.isEmpty(time)) {
                limitDate.subtract(parseInt(hour), 'hours').subtract(parseInt(min), 'minutes');
            }

            // 예약 가능일 이후 부터 현재까지의 범위 안에 예약일시가 있어야 예약 가능
            return Utils.isDateInRange(reservDate, limitDate.format(dFormat), now.format(dFormat));
        },
        onCloseCalendar() {
            this.groupPop = false;
            this.calendarStaffId = '';
            this.batchLesson = [];

            const len = this.$refs.groupReserveTable.length;
            const len1 = this.$refs.batchReserveTable.length;
            for (let i = 0; i < len; i++) {
                this.$refs.groupReserveTable[i].resetSelected();
            }

            for (let i = 0; i < len1; i++) {
                this.$refs.batchReserveTable[i].resetSelected();
            }
            this.batchReservationPop = false;
            this.batchReservationPopNew = false;

            this.countCheckedCalendar = 0;

            // 듀엣 일괄등록 모달 초기화
            this.duetCalendarStaffId = '';
            if (this.selectedTicketList.length > 1) {
                this.selectedTicketList.pop();
                this.selectedTicketValueList.pop();
            }
            this.selectedScheduleList = [];
            this.selectedScheduleValueList = [];
        },
        onCloseCalendarNew() {
            this.batchReservationPopNew = false;
            // 듀엣 일괄등록 모달 초기화
            this.duetCalendarStaffId = '';
            if (this.selectedTicketList.length > 1) {
                this.selectedTicketList.pop();
                this.selectedTicketValueList.pop();
            }
            this.selectedScheduleList = [];
            this.selectedScheduleValueList = [];
        },
        async onCloseGroupBatchResult() {
            await this.fetchAllLessonScheduleIds();
            await this.fetchLessonSchedules();

            this.onCloseCalendar();
            this.infoPop = false;
        },
        async onClickBtnCancelLessonReservation(reserv) {
            if (!confirm('이 예약을 취소하시겠습니까?')) {
                return false;
            }

            try {
                const { cls_center_less_schd_master_id, cls_center_less_schd_id, clsc_center_cust_id } = reserv;
                const params = {
                    scheduleMasterId: cls_center_less_schd_master_id,
                    scheduleId: cls_center_less_schd_id,
                    customerId: clsc_center_cust_id,
                    attendanceDevice: 'AW',
                    scheduleCancelReason: '',
                    reservationType: 'S',
                    reservationId: this.loginId,
                };
                // scheduleMasterId, scheduleId, customerId, attendanceDevice, scheduleCancelReason

                await this.deleteLessonSchedule(params);
                await this.fetchLessonSchedules();
            } catch (e) {
                console.log(e);
                Utils.alertResponseErrorMessge(e);
            }
        },
        async onClickBtnMultiCancelLessonReservation() {
            if (this.checkScheduleList.length === 0) {
                alert('선택된 스케쥴이 없습니다.');
                return false;
            }
            if (!confirm('선택한 예약을 취소하시겠습니까?')) {
                return false;
            }

            try {
                const params = [];

                for (const data of this.checkScheduleList) {
                    const { cls_center_less_schd_master_id, cls_center_less_schd_id, clsc_center_cust_id } = data;
                    const param = {
                        scheduleMasterId: cls_center_less_schd_master_id,
                        scheduleId: cls_center_less_schd_id,
                        customerId: clsc_center_cust_id,
                        attendanceDevice: 'AW',
                        scheduleCancelReason: '',
                        reservationType: 'S',
                        reservationId: this.loginId,
                    };
                    params.push(param);
                }

                // console.log('params: ', params);

                await this.deleteLessonScheduleMulti(params);
                await this.fetchLessonSchedules();
            } catch (e) {
                console.log(e);
                Utils.alertResponseErrorMessge(e);
            }
        },
        async onClickBtnChangeLessonReservation(reservation) {
            if (this.ticketType === 'G' || this.ticketType === 'C') {
                const selectedTeacher = reservation.cls_less_staff_id;
                const preset = {
                    selectedTeacher,
                    selectedCustomer: {
                        id: this.selectedCustomer.centerCustomerId,
                        name: this.selectedCustomer.name,
                    },
                    selectedProduct: this.currentProduct,
                    lessonDate: moment(reservation.cls_less_dt).format('YYYY-MM-DD'),
                    scheduleId: reservation.cls_center_less_schd_id,
                    orgScheduleId: reservation.cls_center_less_schd_id,
                    isModify: true,
                };

                await this.$refs.groupReservationDlg.setPresetData(preset);

                this.groupReservPop = true;
                this.$refs.groupReservationDlg.show();
            } else {
                const preset = await this.getLessonReservationPreset(reservation);
                await this.$refs.lessonReservationDlg.setPresetData(preset);

                this.reservationPop = true;

                this.$refs.lessonReservationDlg.show();
            }
        },
        deleteLessonSchedule(params) {
            // 스웨거 검색: 예약수업 취소처리
            return api.delete(`/admin/api/center/${this.centerId}/lesson/schedule/cancelLesson`, { params });
        },
        deleteLessonScheduleMulti(params) {
            // 스웨거 검색: 예약수업 일괄취소처리
            return api.post(`/admin/api/center/${this.centerId}/lesson/schedule/cancelLessonMulti`, {
                deleteScheduleRequestList: params,
            });
        },
        async getLessonReservationPreset(reservation) {
            const preset = {};

            // 회원 정보
            const customer = this.selectedCustomer;

            // 현 메뉴에서만 셋팅되는 정보 (중요) : 수정창의 항목이 달라짐
            preset.selectedProduct = this.currentProduct;

            // 수정을 위한 중요 정보
            preset.centerContractId = this.centerContractId;

            // 수정 기본 정보
            preset.isModify = true;
            preset.centerLessonScheduleId = reservation.cls_center_less_schd_id;
            preset.centerLessonScheduleMasterId = reservation.cls_center_less_schd_master_id;

            preset.selectedTeacher = reservation.cls_less_staff_id;
            preset.selectedCustomer = {
                name: customer.name,
                id: customer.centerCustomerId,
            };

            // preset.lessonDate = Utils.getYmd(reservation.cls_less_dt);
            preset.lessonDate = moment(reservation.cls_less_dt).format('YYYY-MM-DD');
            const lessonTimeArr = reservation.cls_less_start_tm.split(':');
            preset.startHour = lessonTimeArr[0];
            preset.startMin = lessonTimeArr[1];
            preset.lessonTime = reservation.cls_less_total_tm;
            preset.memo = reservation.cls_less_memo;

            // 방정보 셋팅
            preset.rooms = [];

            const { data: lessonScheduleDetail } = await this.getCenterCustomerLessonScheduleDetail(
                reservation.cls_center_less_schd_id
            );
            preset.lessonDate = lessonScheduleDetail.lessonDate;

            if (!Utils.isEmpty(lessonScheduleDetail.rooms)) {
                for (const room of lessonScheduleDetail.rooms) {
                    const useStartTime = room.useStartTime.split('+')[0].substring(0, 5);
                    const useEndTime = room.useEndTime.split('+')[0].substring(0, 5);
                    preset.rooms.push({
                        centerRoomId: room.centerRoomId,
                        useStartTime,
                        useEndTime,
                    });
                }
            }

            return preset;
        },
        getCenterCustomerLessonScheduleDetail(centerLessonScheduleId) {
            // 스웨거 검색: 회원 예약 스케줄 상세 조회
            return api.get(
                `/admin/api/center/${this.centerId}/lesson/schedule/${centerLessonScheduleId}/customer/${this.centerCustomerId}/detail`
            );
        },
        updateSelectProduct(val) {
            const { list } = this.selectFormProduct;
            this.selectFormProduct.selectedValue = val;

            if (this.selectFormProduct.selectedValue === this.centerContractId) {
                return false;
            }

            const index = this.selectFormProduct.value.indexOf(val);
            const centerContractId = index === -1 || list.length === 0 ? this.centerContractId : list[index];

            this.$router.push({
                path: '/madmin/course/care/reserve',
                query: {
                    customerId: this.centerCustomerId,
                    contractId: centerContractId,
                    centerProductId: val,
                },
            });

            /*
      for(let product of this.selectFormProduct.list) {
          if(product.centerContractId === val) {
              this.$router.push({
                  path: '/madmin/course/care/reserve',
                  query: {
                      customerId : product.centerCustomerId,
                      contractId: product.centerContractId,
                      centerProductId:product.centerProductId
                  }
              });
              break;
          }
      }
       */
        },
        initAttendanceData() {
            this.joinSeq = '';
            this.centerLessonScheduleId = '';
            this.custName = '';
            this.popupInfo = {};
            this.absentReason = '';
        },
        isAllowedModify(sc) {
            return this.isAllowed('SC', 1) || sc.cls_less_staff_id === this.staffId;
        },
        checkAllowedClickAttendAction(sch, successCallback) {
            // 출결 승인 관리 권한
            if (this.isAllowed('SC', 4) || (this.isAllowed('SC', 3) && sch.cls_less_staff_id === this.staffId)) {
                // 전체 권한이 있거나, 본인만 권한이 있는 경우
                successCallback();
            } else {
                alert('사용권한이 없습니다. 대표관리자에게 권한을 요청하세요.');
                return false;
            }
        },
        isCancelStatus(resv) {
            return resv.clsc_resv_status_cd === 'RC';
        },
        async excelDownload() {
            const { data } = await this.getLessonScheduleExcel(); // 엑셀용 요청값

            const excelDownloadArray = [];
            data.items.forEach((member, index) => {
                const temp = {};
                temp['회차'] = index + 1;
                temp['강사명'] = member.cls_less_staff_nm;
                temp['수업일자'] = moment(member.cls_less_dt).format('YYYY-MM-DD');
                temp['시작시간'] = member.cls_less_start_tm.toString().slice(0, 5);
                temp['수업시간'] = this.convertLessonTime(member.cls_less_total_tm);
                temp['룸 선택'] = this.getRoomInfo(member.cls_center_room_info);
                temp['출결현황'] = Utils.getAttendanceStatusName(member.clsc_atnd_status_cd);
                temp['정산현황'] = this.getBillStatusString(member.clsc_bill_status_cd);

                excelDownloadArray.push(temp);
            });

            /* [Key:value, ...] */
            const dataWS = XLSX.utils.json_to_sheet(excelDownloadArray);

            // cell width 설정
            const wscols = [
                { wch: 12 },
                { wch: 24 },
                { wch: 50 },
                { wch: 30 },
                { wch: 12 },
                { wch: 35 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
            ];
            dataWS['!cols'] = wscols;

            // cell height 설정
            const wsrows = [{ hpx: 30 }];
            dataWS['!rows'] = wsrows;

            const wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, dataWS, '스케줄 예약');
            XLSX.writeFile(wb, '스케줄 예약.xlsx');
        },
        // 기간을 연장하는 함수
        periodInit() {
            this.periodPop = false;
        },
        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.limit = val;
            this.fetchLessonSchedules();
        },
        convertTicketLessonTime(lessonTime) {
            const hour = Math.floor(Number(lessonTime) / 60);
            let minute = Number(lessonTime) % 60;

            minute = minute < 10 ? `0${minute}` : `${minute}`;

            if (hour === 0 && minute === 0) {
                return;
            } else if (minute === '00') {
                return `${hour}시간`;
            } else if (hour === 0) {
                return `${minute}분`;
            }

            return `${hour}시간 ${minute}분`;
        },
        onUpdateStaff(val) {
            this.calendarStaffId = val;
            this.countCheckedCalendar = 0;

            for (let i = 0; i < this.checkedCalendarLesson.length; i++) {
                this.checkedCalendarLesson[i] = [];
            }

            for (const month of this.$refs.groupReserveTable) {
                month.selected = [];
                month.selectedLesson = [];

                if (!month.$refs.checkLesson) continue;

                for (const checkLesson of month.$refs.checkLesson) {
                    checkLesson.checked = false;
                }
            }
        },

        onUpdateMonth(month, index) {
             this.$refs.groupReserveTable[index].$el.scrollIntoView({ behavior: 'auto' });
        },

        getLessonScheduleExcel() {
            return api.get(
                `/admin/api/center/${this.centerId}/lesson/schedule/product/${this.centerProductId}/customer/${this.centerCustomerId}/contract/${this.centerContractId}`,
                {
                    params: {
                        ...this.pagingInfo,
                        sortType: 'DESC',
                        sortColumn: 'lessonDate',
                        limit: 10000,
                    },
                }
            );
        },
        getRoomInfo(roomInfo) {
            const rooms = this.getRoomInfos(roomInfo);

            let result = '';

            for (let i = 0; i < rooms.length; i++) {
                result += `${rooms[i].startTime} ~ ${rooms[i].endTime} ${rooms[i].name}`;

                if (i !== rooms.length - 1) result += '\n';
            }

            return result;
        },
        getBillStatusString(billStatus) {
            switch (billStatus) {
                case 'O':
                    return '정산승인';
                case 'X':
                    return '정산취소';
                case '-':
                    return '정산미승인';
            }
        },
        // 전체선택 체크박스 선택시
        allCheckBox() {
            const checkBoxArray = document.getElementsByName('check-1');
            const allCheckBox = document.getElementsByName('check-1')[0];
            const checkBoxLength = checkBoxArray.length;
            if (this.isLast) {
                this.isLast = false;
                return;
            }

            for (let i = 1; i < checkBoxLength; i++) {
                if (allCheckBox.checked === true && checkBoxArray[i].checked === false) {
                    checkBoxArray[i].click();
                } else if (allCheckBox.checked === false && checkBoxArray[i].checked === true) {
                    checkBoxArray[i].click();
                }
            }
        },
        getCenterContractBillTicketList() {
            const pageInfo = {
                page: 1, // 페이지
                limit: 500, // 한 목록에 표출되는 건수
            };
            const params = {
                ticketType: 'D', // 듀엣 이용권
                sortType: this.ticketSortType, // 정렬방법 (오름차순 : ASC, 내림차순 : DESC)
                sortColumn: this.ticketSortColumn, // 정렬컬럼
            };
            // 스웨거 검색: 센터회원계약 이용권 결제 목록 조회/매출현황(상품)
            return api.get(`/admin/api/center/${this.centerId}/customer/0/contract/bill/ticket`, {
                params: {
                    ...pageInfo,
                    ...params,
                },
            });
        },
        // 듀엣 이용권 리스트 조회
        async fetchCenterContractBillTicketList() {
            try {
                // 이용권 전체 리스트
                const { data } = await this.getCustomerProductTicketList();
                // const { data } = await this.getCenterContractBillTicketList();
                // console.log("getCustomerProductTicketList : ", data);

                // 내 이용권 리스트
                const { data: myData } = await this.getTicketProductList();

                // 개인, 듀엣 필터링
                const ticketList = data.filter((ticket) => {
                    if (this.ticketType === 'P') {
                        return ticket.centerProduct.ticketType === 'P' || ticket.centerProduct.ticketType === 'O';
                    } else if (this.ticketType === 'O') {
                        return ticket.centerProduct.ticketType === 'O';
                    } else if (this.ticketType === 'D') {
                        return ticket.centerProduct.ticketType === 'D';
                    }
                });

                ticketList.forEach(async (g) => {
                    if (!g.centerCustomer || !g.centerProduct) {
                        return;
                    }

                    let lessonCount = '';

                    // 출석 현황
                    if (g.lessonCountType === 'T') {
                        lessonCount = `총 ${g.lessonResvCount}/${g.lessonCount}`;
                    } else if (g.lessonCountType === 'W') {
                        lessonCount = `주 ${g.lessonResvCount}/${g.lessonCount}`;
                    } else if (g.lessonCountType === 'U') {
                        lessonCount = `무제한`;
                    }

                    // 셀렉트 박스 name
                    const name = `${g.centerCustomer.name} | ${maskCustomerPhone(this.splitPhoneNumber(g.centerCustomer.phone).join('-'))}
                ${this.convertTicketTypeFormat(g.centerProduct.ticketType)} ${
                        g.productName
                    } | ${this.convertTicketLessonTime(g.centerProduct.lessonTime)} | ${lessonCount} | ${
                        g.expireStartDt
                    } ~ ${g.expireEndDt}`;

                    // 유효 이용권 필터링
                    if (
                        this.centerContractId != g.centerContractId &&
                        moment(g.expireEndDt).isSameOrAfter(moment(), 'day') &&
                        moment(g.expireStartDt).isSameOrBefore(this.expireEndDate) &&
                        this.currentProduct.centerProduct.lessonTime == g.centerProduct.lessonTime
                    ) {
                        this.centerContractBillTicketNameList.push(name);
                        this.centerContractBillTicketValueList.push(g);
                    }

                    // 내 이용권 추가
                    /*
                if(this.centerContractId == g.centerContractId) {
                        this.selectedTicketList.push(name);
                        this.selectedTicketValueList.push(g);
                }
                */
                });

                // 내 이용권
                myData.forEach((g) => {
                    let lessonCount = '';

                    // 출석 현황
                    if (g.lessonCountType === 'T') {
                        lessonCount = `총 ${g.lessonResvCount}/${g.lessonCount}`;
                    } else if (g.lessonCountType === 'W') {
                        lessonCount = `주 ${g.lessonResvCount}/${g.lessonCount}`;
                    } else if (g.lessonCountType === 'U') {
                        lessonCount = `무제한`;
                    }

                    // 셀렉트 박스 name
                    const name = `${g.centerCustomer.name} | ${maskCustomerPhone(this.splitPhoneNumber(g.centerCustomer.phone).join('-'))}
                  ${this.convertTicketTypeFormat(g.centerProduct.ticketType)} ${
                        g.productName
                    } | ${this.convertTicketLessonTime(g.centerProduct.lessonTime)} | ${lessonCount} | ${
                        g.expireStartDt
                    } ~ ${g.expireEndDt}`;

                    if (this.centerContractId == g.centerContractId) {
                        this.selectedTicketList.push(name);
                        this.selectedTicketValueList.push(g);
                    }
                });

                /*
                console.log("centerContractBillTicketValueList : ", this.centerContractBillTicketValueList);
                console.log("centerContractBillTicketNameList : ", this.centerContractBillTicketNameList);
                console.log("selectedTicketList : ", this.selectedTicketList);
                console.log("selectedTicketValueList : ", this.selectedTicketValueList);
                */
            } catch (error) {
                console.log(error);
            }
        },
        // 연락처 split
        splitPhoneNumber(phoneNumber) {
            // console.log(phoneNumber);

            if (!phoneNumber) return phoneNumber;

            phoneNumber = phoneNumber.replace(/[^0-9]/g, '');

            const tmp = ['', '', ''];
            if (phoneNumber.length < 4) {
                return phoneNumber;
            } else if (phoneNumber.length < 7) {
                tmp[0] = phoneNumber.substr(0, 3);
                tmp[1] = phoneNumber.substr(3);
            } else if (phoneNumber.length == 8) {
                tmp[0] = phoneNumber.substr(0, 4);
                tmp[1] = phoneNumber.substr(4);
            } else if (phoneNumber.length < 10) {
                if (phoneNumber.substr(0, 2) == '02') {
                    // 02-123-5678
                    tmp[0] = phoneNumber.substr(0, 2);
                    tmp[1] = phoneNumber.substr(2, 3);
                    tmp[2] = phoneNumber.substr(5);
                }
            } else if (phoneNumber.length < 11) {
                if (phoneNumber.substr(0, 2) == '02') {
                    // 02-1234-5678
                    tmp[0] = phoneNumber.substr(0, 2);
                    tmp[1] = phoneNumber.substr(2, 4);
                    tmp[2] = phoneNumber.substr(6);
                } else {
                    // 010-123-4567
                    tmp[0] = phoneNumber.substr(0, 3);
                    tmp[1] = phoneNumber.substr(3, 3);
                    tmp[2] = phoneNumber.substr(6);
                }
            } else {
                // 010-1234-5678
                tmp[0] = phoneNumber.substr(0, 3);
                tmp[1] = phoneNumber.substr(3, 4);
                tmp[2] = phoneNumber.substr(7);
            }
            return tmp;
        },
        onUpdateTicketWith(val) {
            // console.log('onUpdateTicketWith: ', val);
            if (val === '') return false;

            if (this.selectedTicketList.length == 1 && this.selectedTicketValueList.length == 1) {
                const index = this.centerContractBillTicketValueList.findIndex(
                    (ticket) => ticket.centerContractId == val.centerContractId
                );
                this.selectedTicketList.push(this.centerContractBillTicketNameList[index]);
                this.selectedTicketValueList.push(val);
            }
        },
        async updateLessonDate(date) {
            // console.log('updateLessonDate: ', date);
            // this.lessonDate = date;
        },
        onClickBtnInitSelectedScheduleList() {
            this.selectedScheduleList = [];
            this.selectedScheduleValueList = [];
        },
        async onClickBtnRegistDuetReservation() {
            if (!this.isAllowed('SC', 1) && this.duetCalendarStaffId !== this.staffId) {
                alert('사용권한이 없습니다. 대표관리자에게 권한을 요청하세요.');
                return false;
            }

            // 값 체크 및 확인
            if (!confirm('예약을 등록하시겠습니까?')) {
                return;
            }

            // 등록
            const params = this.getParams();
            // console.log('params: ', params);

            try {
                await this.postLessonScheduleMulti(params).then((res) => {
                    // console.log('res: ', res);
                    if (res.status == 200) {
                        this.fetchLessonSchedules();
                        this.batchReservationPopNew = false;
                    } else {
                        alert('오류가 발생하였습니다.');
                    }
                });
            } catch (e) {
                Utils.alertResponseErrorMessge(e);
                // alert(e.response.data.message);
            }
        },
        getParams() {
            const params = [];
            /*
            console.log('centerCustomerId: ', this.centerCustomerId);
            console.log('centerProductId: ', this.centerProductId);
            */

            for (const ticket of this.selectedTicketValueList) {
                for (const schedule of this.selectedScheduleValueList) {
                    const param = {
                        centerLessonScheduleMasterId: 0,
                        centerCustomerId: ticket.centerCustomerId,
                        reservationDevice: 'AW', // 등록 디바이스 고정값 (관리자웹 [ 관리자웹 : AW, 관리자앱 : AA, 회원앱 : CA, 터치모니터 : TU ])
                        reservationType: 'S', // 등록 주체 구분 고정값 ([직원 : S, 회원 : M])
                        reservationId: this.staffId, // 등록자 아이디
                        centerContractId: ticket.centerContractId,
                        centerProductId: ticket.centerProductId,
                        centerCustomerName: ticket.centerCustomer.name,
                        lessonStaffId: schedule.staffId,
                        dayOfWeek: Utils.getDayOfWeekName(schedule.lessonDate),
                        lessonDate: schedule.lessonDate,
                        lessonStartTime: schedule.lessonStartTime,
                        lessonEndTime: schedule.lessonEndTime,
                        lessonsType: ticket.centerProduct.ticketType,
                        roomInfos: schedule.roomInfos,
                    };
                    params.push(param);
                }
            }

            return params;
        },
        // 선택한 이용권 삭제
        deleteTicket(index) {
            // console.log('deleteTicket: ', index);
            if (index === '') return false;

            this.selectedTicketList.splice(index, 1);
            this.selectedTicketValueList.splice(index, 1);
        },
        // 선택한 일정 삭제
        deleteSchedule(index) {
            // console.log('deleteSchedule: ', index);
            if (index === '') return false;

            this.selectedScheduleList.splice(index, 1);
            this.selectedScheduleValueList.splice(index, 1);
        },
        postLessonScheduleMulti(params, centerLessonScheduleId = 0) {
            // @스웨거검색: 회원 수업 스케줄 예약하기(개인/OT/듀엣)
            return api.post(`/admin/api/center/${this.centerId}/lesson/schedule/multi`, { inputs: params });
        },
        async onUpdateStaffDuet(val) {
            if (val === '') return false;
            this.duetCalendarStaffId = val;
        },
        async onClickBtnLessonBatchReservationNew() {
            this.duetCalendarStaffId = this.staffId;
            this.batchReservationPopNew = true;
            this.selectedRoom = null;
            this.selectFormStartHour.selectedValue = '00';
            this.selectFormStartMin.selectedValue = '00';
            await this.setupRoom();
        },
        // 이용권(비 그룹레슨) 목록조회
        getCustomerProductTicketList() {
            // 스웨거 검색: 이용권(비 그룹레슨) 목록조회
            return api.get(`/admin/api/center/${this.centerId}/customer/ticket/notGroup`);
        },
    },
};
</script>

<style lang="scss" scoped>
.top-select {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.break {
  flex-basis: 100%;
  height: 0;
}

.mx-calendar {
    height: 370px;
}

.select-form-dropdown {
    z-index: 1000; /* Adjust the value according to your needs */
}

</style>
